<div [ngSwitch]="question.type" *ngIf="question" class="q-pro-card-p-0 {{
    questionIndex == editingIndex && !disabled && !disabled
      ? 'card-active-bg'
      : 'card-deactive-bg'
  }}" (click)="((disabled && isConditional) || (disabled && isLinked)) ? showErrorCond() : null">
  <div class=" {{
      questionIndex == editingIndex && !disabled
        ? 'border-right-active-card-ui'
        : ''
    }} py-4">
    <div class="d-flex justify-content-start column">
      <div *ngIf="!UserExternalFields" class="pos-rel">
        <div class="pos-abs-1">
          <button class="{{
              questionIndex == editingIndex && !disabled
                ? 'Q-no-Active'
                : 'Q-no-Dactive'
            }}">
            <!-- {{ question.questionCode }} -->
            Q{{questionIndex+1}}
          </button>
        </div>
      </div>
      <div class="mx-mob-2 column">
        <ng-container *ngSwitchCase="'SELECT_ONE_IMAGE'">
          <div class="flex-start my-3" *ngIf="(disabled && isConditional) || (disabled && isLinked)">
            <p-button (onClick)="unlockQuestion()" [pTooltip]="'Unlock Question & Edit' | translator"
              styleClass="input-button p-button-rounded p-button-danger p-button-text" icon="pi pi-lock"></p-button>
          </div>
          <div class="row" *ngIf="isAssessment && !UserExternalFields">
            <div class="col-md-6 col-12 d-flex gap-2 justify-content-start my-4">
              <p-button (onClick)="openServiceModal(question)" styleC="qbl-btn"
                label="{{ 'Select Service' | translator }}"></p-button>
              <ng-container *ngIf="question?.meta?.serviceIcon && question?.meta?.servicelabel">
                <div class="minisbutton d-flex gap-2">
                  <img src="{{ staticFileUrl + question?.meta?.serviceIcon }}" class="ministry-logo" />
                  <h5 class="miniheading">
                    {{ question?.meta?.servicelabel }}
                  </h5>
                </div>
                <p-button (onClick)="launchUrl(question.meta.service)" styleC="qbl-btn"
                  label="{{ 'Service' | translator }}" icon="pi pi-external-link"></p-button>
              </ng-container>
            </div>
          </div>
          <div class="input-with-button column flex-row"
            *ngIf="survey.topics != undefined && survey.topics.length > 0 && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{
                "ClassificationQue" | translator
                }}</span>
              <!-- p-dropdown [options]="survey.topics" [(selection)]="question.meta.selectedTopic"  [placeholder]="'Select Question Topics' | translator" ></p-dropdown -->

              <p-tree [value]="survey.topics" selectionMode="single" [(selection)]="question.meta.selectedTopic"
                emptyMessage="{{'No question classification created' | translator}}"
                (onNodeSelect)="toggleSelection($event)"></p-tree>
            </div>
          </div>
          <div class="input-with-button column flex-row" *ngIf="(isAssessment || isTopic) && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start" *ngIf="!fromTraining">
              <span class="ans-color">{{
                "Difficulty Level" | translator
                }}</span>
              <p-dropdown [options]="difficultyLevels" [(ngModel)]="question.meta.difficultyLevel"></p-dropdown>
            </div>
          </div>
          <div class="input-with-button column flex-row my-2" *ngIf="isAssessment && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Marks" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field" placeholder="{{ 'Marks' | translator }}"
                [disabled]="disabled" [inputStyle]="{
                                  'background-color': 'transparent',
                                  'border': 'none',
                                  'border-bottom': 'solid 1px lightgrey',
                                  'border-radius': '0px',
                                  'width': '100%',
                                  'color': 'white',
                              }" [(ngModel)]="question.meta.marks" />
            </div>
          </div>
          <div *ngIf="!UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Description" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.description" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div *ngIf="(isAssessment || isTopic) && !UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Feedback" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.feedback" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div class="column">
            <div class="input-with-button column flex-row my-4 "
              [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
              <input [disabled]="disabled" style="
                  background-color: transparent;
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                  color: white;
                " class="input-field 1" [placeholder]="question.meta.placeholder" [(ngModel)]="question.questionText"
                type="text" pInputText />
              <p-button [disabled]="disabled" *ngIf="questionIndex == editingIndex && !disabled"
                styleClass="input-button p-button-rounded p-button-danger p-button-text"
                (onClick)="removeQuestion(questionIndex, UserExternalFields)" icon="pi pi-trash"></p-button>
            </div>
            <div class="d-flex flex-row flex-wrap">
              <label class="{{
                  question.meta.correct &&
                  question.meta.correct == field.label &&
                  (isAssessment || isTopic)
                    ? 'img-selector-ui-active'
                    : 'img-selector-ui'
                }}" *ngFor="
                  let field of question.meta.fields;
                  let fieldIndex = index
                ">
                <div style="position: relative">
                  <span role="button" (click)="
                      removeRowInTextInput(question, fieldIndex, questionIndex)
                    " class="pi pi-times" style="
                      color: red;
                      position: absolute;
                      top: 0;
                      right: 0;
                      margin: -5px -5px;
                      z-index: 999;
                    "></span>
                  <span *ngIf="isAssessment || isTopic" role="button" (click)="
                      (disabled || (!isAssessment && !isTopic)) ? null : (question.meta.correct = field.label)
                    " class="pi pi-check" style="
                      color: green;
                      position: absolute;
                      top: 0;
                      left: 0;
                      margin: -5px -5px;
                      z-index: 999;
                    "></span>
                  <span class="d-flex flex-column align-items-center justify-content-center">
                    <i (click)="selectImage(imageSelector)" *ngIf="!field.url; else imageTemplate"
                      class="pi pi-image selector-icn"></i>
                    <ng-template #imageTemplate>
                      <img style="width: 5rem; height: 5rem" (click)="selectImage(imageSelector)"
                        src="{{ staticFileUrl + field.url }}" alt="question image" />
                    </ng-template>
                    <input #imageSelector [disabled]="true" (change)="
                        disabled ? null : onQuestionImageSelect($event, field)
                      " type="file" [multiple]="false" class="form-control inputboxy" dir="rtl"
                      placeholder="Survey Image" />
                    <input [disabled]="disabled" style="
                        background-color: transparent;
                        text-align: center;
                        border: none;
                        border-bottom: solid 1px lightgrey;
                        border-radius: 0px;
                        width: 100%;
                        color: white;
                      " class="input-field p-0" [placeholder]="field.placeholder" 
[(ngModel)]="field.label"
(focus)="storeOldValue(field)"
                  (ngModelChange)="onLabelChange(field, $event)" type="text"
                      pInputText />
                  </span>
                </div>
              </label>
            </div>
            <div class="col-md-12 col-12 my-2" *ngIf="questionIndex == editingIndex && !disabled">
              <p-button class="v4-plus" [disabled]="disabled" (onClick)="addRowInTextInput(question, questionIndex)"
                icon="pi pi-plus" styleClass="p-button-rounded p-button-outlined"></p-button>
            </div>
          </div>
          <!-- select one img End -->
        </ng-container>
        <ng-container *ngSwitchCase="'SELECT_MANY_IMAGE'">
          <div class="flex-start my-3" *ngIf="(disabled && isConditional) || (disabled && isLinked)">
            <p-button (onClick)="unlockQuestion()" [pTooltip]="'Unlock Question & Edit' | translator"
              styleClass="input-button p-button-rounded p-button-danger p-button-text" icon="pi pi-lock"></p-button>
          </div>
          <div class="row" *ngIf="isAssessment && !UserExternalFields">
            <div class="col-md-6 col-12 d-flex gap-2 justify-content-start my-4">
              <p-button (onClick)="openServiceModal(question)" styleC="qbl-btn"
                label="{{ 'Select Service' | translator }}"></p-button>
              <ng-container *ngIf="question?.meta?.serviceIcon && question?.meta?.servicelabel">
                <div class="minisbutton d-flex gap-2">
                  <img src="{{ staticFileUrl + question?.meta?.serviceIcon }}" class="ministry-logo" />
                  <h5 class="miniheading">
                    {{ question?.meta?.servicelabel }}
                  </h5>
                </div>
                <p-button (onClick)="launchUrl(question.meta.service)" styleC="qbl-btn"
                  label="{{ 'Service' | translator }}" icon="pi pi-external-link"></p-button>
              </ng-container>
            </div>
          </div>
          <div class="input-with-button column flex-row"
            *ngIf="survey.topics != undefined && survey.topics.length > 0 && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{
                "ClassificationQue" | translator
                }}</span>
              <!-- p-dropdown [options]="survey.topics" [(selection)]="question.meta.selectedTopic"  [placeholder]="'Select Question Topics' | translator" ></p-dropdown -->

              <p-tree [value]="survey.topics" selectionMode="single" [(selection)]="question.meta.selectedTopic"
                emptyMessage="{{'No question classification created' | translator}}"
                (onNodeSelect)="toggleSelection($event)"></p-tree>
            </div>
          </div>
          <div class="input-with-button column flex-row" *ngIf="(isAssessment || isTopic) && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start" *ngIf="!fromTraining">
              <span class="ans-color">{{
                "Difficulty Level" | translator
                }}</span>
              <p-dropdown [options]="difficultyLevels" [(ngModel)]="question.meta.difficultyLevel"></p-dropdown>
            </div>
          </div>
          <div class="input-with-button column flex-row my-2" *ngIf="isAssessment && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Marks" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field" placeholder="{{ 'Marks' | translator }}"
                [disabled]="disabled" [inputStyle]="{
                                  'background-color': 'transparent',
                                  'border': 'none',
                                  'border-bottom': 'solid 1px lightgrey',
                                  'border-radius': '0px',
                                  'width': '100%',
                                  'color': 'white',
                              }" [(ngModel)]="question.meta.marks" />
            </div>
          </div>
          <div *ngIf="!UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Description" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.description" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div *ngIf="(isAssessment || isTopic) && !UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Feedback" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.feedback" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <!-- select many img -->
          <div class="column">
            <div class="input-with-button column flex-row my-4 "
              [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
              <input [disabled]="disabled" style="
                  background-color: transparent;
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                  color: white;
                " class="input-field 2" [placeholder]="question.meta.placeholder" [(ngModel)]="question.questionText"
                type="text" pInputText />
              <p-button [disabled]="disabled" *ngIf="questionIndex == editingIndex && !disabled"
                styleClass="input-button p-button-rounded p-button-danger p-button-text"
                (onClick)="removeQuestion(questionIndex, UserExternalFields)" icon="pi pi-trash"></p-button>
            </div>
            <div class="d-flex flex-row flex-wrap">
              <label class="{{
                  question.meta.correct?.includes(field.label) &&
                  (isAssessment || isTopic)
                    ? 'img-selector-ui-active'
                    : 'img-selector-ui'
                }}" *ngFor="
                  let field of question.meta.fields;
                  let fieldIndex = index
                ">
                <div style="position: relative">
                  <span role="button" (click)="
                      removeRowInTextInput(question, fieldIndex, questionIndex)
                    " class="pi pi-times" style="
                      color: red;
                      position: absolute;
                      top: 0;
                      right: 0;
                      margin: -5px -5px;
                      z-index: 999;
                    "></span>
                  <span *ngIf="isAssessment || isTopic" role="button"
                    (click)=" (disabled || (!isAssessment && !isTopic)) ? null : addImageToSelected(question, field.label)"
                    class="pi pi-check" style="
                      color: green;
                      position: absolute;
                      top: 0;
                      left: 0;
                      margin: -5px -5px;
                      z-index: 999;
                    "></span>
                  <span class="d-flex flex-column align-items-center justify-content-center">
                    <i (click)="selectImage(imageSelector)" *ngIf="!field.url; else imageTemplate"
                      class="pi pi-image selector-icn"></i>
                    <ng-template #imageTemplate>
                      <img style="width: 5rem; height: 5rem" (click)="selectImage(imageSelector)"
                        src="{{ staticFileUrl + field.url }}" alt="question image" />
                    </ng-template>
                    <input #imageSelector [disabled]="true" (change)="
                        disabled ? null : onQuestionImageSelect($event, field)
                      " type="file" [multiple]="false" class="form-control inputboxy" dir="rtl"
                      placeholder="Survey Image" />
                    <input [disabled]="disabled" style="
                        background-color: transparent;
                        text-align: center;
                        border: none;
                        border-bottom: solid 1px lightgrey;
                        border-radius: 0px;
                        width: 100%;
                        color: white;
                      " class="input-field p-0" [placeholder]="field.placeholder" 
                  [(ngModel)]="field.label"
                  (focus)="storeOldValue(field)"
                  (ngModelChange)="onLabelChange(field, $event)" type="text"
                      pInputText />
                  </span>
                </div>
              </label>
            </div>
            <div class="col-md-12 col-12 my-2" *ngIf="questionIndex == editingIndex && !disabled">
              <p-button class="v4-plus" [disabled]="disabled" (onClick)="addRowInTextInput(question, questionIndex)"
                icon="pi pi-plus" styleClass="p-button-rounded p-button-outlined"></p-button>
            </div>
          </div>
          <!-- select many img End -->
        </ng-container>
        <ng-container *ngSwitchCase="'SMILE_RATING'">
          <div class="flex-start my-3" *ngIf="(disabled && isConditional) || (disabled && isLinked)">
            <p-button (onClick)="unlockQuestion()" [pTooltip]="'Unlock Question & Edit' | translator"
              styleClass="input-button p-button-rounded p-button-danger p-button-text" icon="pi pi-lock"></p-button>
          </div>
          <div class="row" *ngIf="isAssessment && !UserExternalFields">
            <div class="col-md-6 col-12 d-flex gap-2 justify-content-start my-4">
              <p-button (onClick)="openServiceModal(question)" styleC="qbl-btn"
                label="{{ 'Select Service' | translator }}"></p-button>
              <ng-container *ngIf="question?.meta?.serviceIcon && question?.meta?.servicelabel">
                <div class="minisbutton d-flex gap-2">
                  <img src="{{ staticFileUrl + question?.meta?.serviceIcon }}" class="ministry-logo" />
                  <h5 class="miniheading">
                    {{ question?.meta?.servicelabel }}
                  </h5>
                </div>
                <p-button (onClick)="launchUrl(question.meta.service)" styleC="qbl-btn"
                  label="{{ 'Service' | translator }}" icon="pi pi-external-link"></p-button>
              </ng-container>
            </div>
          </div>
          <div class="input-with-button column flex-row"
            *ngIf="survey.topics != undefined && survey.topics.length > 0 && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{
                "ClassificationQue" | translator
                }}</span>
              <!-- p-dropdown [options]="survey.topics" [(selection)]="question.meta.selectedTopic"  [placeholder]="'Select Question Topics' | translator" ></p-dropdown -->

              <p-tree [value]="survey.topics" selectionMode="single" [(selection)]="question.meta.selectedTopic"
                emptyMessage="{{'No question classification created' | translator}}"
                (onNodeSelect)="toggleSelection($event)"></p-tree>
            </div>
          </div>
          <div class="input-with-button column flex-row" *ngIf="(isAssessment || isTopic) && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start" *ngIf="!fromTraining">
              <span class="ans-color">{{
                "Difficulty Level" | translator
                }}</span>
              <p-dropdown [options]="difficultyLevels" [(ngModel)]="question.meta.difficultyLevel"></p-dropdown>
            </div>
          </div>
          <div class="input-with-button column flex-row my-2" *ngIf="isAssessment && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Marks" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field" placeholder="{{ 'Marks' | translator }}"
                [disabled]="disabled" [inputStyle]="{
                                  'background-color': 'transparent',
                                  'border': 'none',
                                  'border-bottom': 'solid 1px lightgrey',
                                  'border-radius': '0px',
                                  'width': '100%',
                                  'color': 'white',
                              }" [(ngModel)]="question.meta.marks" />
            </div>
          </div>
          <div *ngIf="!UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Description" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.description" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div *ngIf="(isAssessment || isTopic) && !UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Feedback" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.feedback" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <!-- smiley Rating -->
          <div class="column">
            <div class="input-with-button column flex-row my-4 "
              [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
              <input [disabled]="disabled" style="
                  background-color: transparent;
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                  color: white;
                " class="input-field 3" [placeholder]="question.meta.placeholder" [(ngModel)]="question.questionText"
                type="text" pInputText />
              <p-button [disabled]="disabled" *ngIf="questionIndex == editingIndex && !disabled"
                styleClass="input-button p-button-rounded p-button-danger p-button-text"
                (onClick)="removeQuestion(questionIndex, UserExternalFields)" icon="pi pi-trash"></p-button>
            </div>
            <div class="row">
              <div class="col-md-12 col-12 my-2">
                <div class="d-flex flex-wrap mobile-centr">
                  <div class="column {{
                      question.meta.correct == field.label && field.label != '' &&
                      (isAssessment || isTopic)
                        ? 'rating-bg-active'
                        : 'rating-bg'
                    }} " (click)="
                      (isAssessment || isTopic) && !disabled && field.label != ''
                        ? (question.meta.correct = field.label)
                        : null
                    " *ngFor="let field of question.meta.fields">
                    <span>
                      <img class="rating-width" src="{{ field.image }}" alt="loading" />
                    </span>
                    <span>
                      <input [disabled]="disabled" style="
                          background-color: transparent;
                          text-align: center;
                          border: none;
                          border-bottom: solid 1px lightgrey;
                          border-radius: 0px;
                          width: 100%;
                          color: white;
                        " class="input-field p-0" [placeholder]="field.placeholder" 
                  [(ngModel)]="field.label"
                  (focus)="storeOldValue(field)"
                  (ngModelChange)="onLabelChange(field, $event)"
                        type="text" pInputText />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- smiley Rating End -->
        </ng-container>
        <ng-container *ngSwitchCase="'MULTI_POINT_SCALE'">
          <div class="flex-start my-3" *ngIf="(disabled && isConditional) || (disabled && isLinked)">
            <p-button (onClick)="unlockQuestion()" [pTooltip]="'Unlock Question & Edit' | translator"
              styleClass="input-button p-button-rounded p-button-danger p-button-text" icon="pi pi-lock"></p-button>
          </div>
          <div class="row" *ngIf="isAssessment && !UserExternalFields">
            <div class="col-md-6 col-12 d-flex gap-2 justify-content-start my-4">
              <p-button (onClick)="openServiceModal(question)" styleC="qbl-btn"
                label="{{ 'Select Service' | translator }}"></p-button>
              <ng-container *ngIf="question?.meta?.serviceIcon && question?.meta?.servicelabel">
                <div class="minisbutton d-flex gap-2">
                  <img src="{{ staticFileUrl + question?.meta?.serviceIcon }}" class="ministry-logo" />
                  <h5 class="miniheading">
                    {{ question?.meta?.servicelabel }}
                  </h5>
                </div>
                <p-button (onClick)="launchUrl(question.meta.service)" styleC="qbl-btn"
                  label="{{ 'Service' | translator }}" icon="pi pi-external-link"></p-button>
              </ng-container>
            </div>
          </div>
          <div class="input-with-button column flex-row"
            *ngIf="survey.topics != undefined && survey.topics.length > 0 && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{
                "ClassificationQue" | translator
                }}</span>
              <!-- p-dropdown [options]="survey.topics" [(selection)]="question.meta.selectedTopic"  [placeholder]="'Select Question Topics' | translator" ></p-dropdown -->

              <p-tree [value]="survey.topics" selectionMode="single" [(selection)]="question.meta.selectedTopic"
                emptyMessage="{{'No question classification created' | translator}}"
                (onNodeSelect)="toggleSelection($event)"></p-tree>
            </div>
          </div>
          <div class="input-with-button column flex-row" *ngIf="(isAssessment || isTopic) && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start" *ngIf="!fromTraining">
              <span class="ans-color">{{
                "Difficulty Level" | translator
                }}</span>
              <p-dropdown [options]="difficultyLevels" [(ngModel)]="question.meta.difficultyLevel"></p-dropdown>
            </div>
          </div>
          <div class="input-with-button column flex-row my-2" *ngIf="isAssessment && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Marks" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field" placeholder="{{ 'Marks' | translator }}"
                [disabled]="disabled" [inputStyle]="{
                                  'background-color': 'transparent',
                                  'border': 'none',
                                  'border-bottom': 'solid 1px lightgrey',
                                  'border-radius': '0px',
                                  'width': '100%',
                                  'color': 'white',
                              }" [(ngModel)]="question.meta.marks" />
            </div>
          </div>
          <div *ngIf="!UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Description" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.description" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div *ngIf="(isAssessment || isTopic) && !UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Feedback" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.feedback" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <!-- Multi point Scale -->
          <div class="column">
            <div class="input-with-button column flex-row my-4 "
              [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
              <input [disabled]="disabled" style="
                  background-color: transparent;
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                  color: white;
                " class="input-field 4" [placeholder]="question.meta.placeholder" [(ngModel)]="question.questionText"
                type="text" pInputText />
              <p-button [disabled]="disabled" styleClass="input-button p-button-rounded p-button-danger p-button-text"
                (onClick)="removeQuestion(questionIndex, UserExternalFields)" icon="pi pi-trash"></p-button>
            </div>
            <section>
              <div class="row">
                <!-- left right anchor section -->
                <div class="col-md-6 col-12 d-flex justify-content-start my-4" *ngIf="false">
                  <input [disabled]="disabled" style="
                      background-color: transparent;
                      border: none;
                      border-bottom: solid 1px lightgrey;
                      border-radius: 0px;
                      width: 200px;
                      color: white;
                    " class="input-field" [placeholder]="question.meta.rightAnchorPlaceholder"
                    [(ngModel)]="question.meta.rightAnchor" type="text" pInputText />
                </div>
                <div class="col-md-6 col-12 d-flex justify-content-start my-4" *ngIf="false">
                  <input [disabled]="disabled" style="
                      background-color: transparent;
                      border: none;
                      border-bottom: solid 1px lightgrey;
                      border-radius: 0px;
                      width: 200px;
                      color: white;
                    " class="input-field" [placeholder]="question.meta.leftAnchorPlaceholder"
                    [(ngModel)]="question.meta.leftAnchor" type="text" pInputText />
                </div>
                <!-- left right anchor section end -->

                <!-- column 1 or 2 section -->
                <div class="col-12 row">
                  <div class="col-md-4 col-12"></div>
                  <div *ngFor="
                      let column of question.meta.columnsPlaceholder;
                      let columnIndex = index
                    " class="col d-flex justify-content-start my-2">
                    <input [disabled]="disabled" style="
                        background-color: transparent;
                        border: none;
                        border-bottom: solid 1px lightgrey;
                        border-radius: 0px;
                        width: 100%;
                        color: white;
                      " class="input-field" type="text" [placeholder]="question.meta.columnsPlaceholder[columnIndex]"
                      [(ngModel)]="question.meta.columns[columnIndex]"
                      (change)="updateColumn(question, $event, columnIndex)" pInputText />
                    <p-button [disabled]="disabled" (onClick)="removeColumn(question, columnIndex)"
                      styleClass="p-button-rounded p-button-danger p-button-text" icon="pi pi-trash"></p-button>
                  </div>
                </div>
                <!-- column 1 or 2 section end -->

                <ng-container *ngFor="let field of question.meta.fields; let rowIndex = index">
                  <div class="col-12 row">
                    <div class="col-12 row">
                      <!-- Row 1 section with radio buttons -->
                      <div class="col-md-4 col-12">
                        <input [disabled]="disabled" style="
                            background-color: transparent;
                            border: none;
                            border-bottom: solid 1px lightgrey;
                            border-radius: 0px;
                            width: 100%;
                            color: white;
                          " class="input-field" [placeholder]="field.field.placeholder" [(ngModel)]="field.field.label"
                          type="text" pInputText />
                      </div>
                      <div class="col-auto mt-1">
                        <p-button [disabled]="disabled" (onClick)="removeRow(question, rowIndex)"
                          styleClass="p-button-rounded p-button-danger p-button-text" icon="pi pi-trash"></p-button>
                      </div>
                      <div class="col d-flex align-items-end" *ngFor="let column of question.meta.columnsPlaceholder">
                        <div style="cursor: pointer" (click)="
                            (disabled || (!isAssessment && !isTopic)) ? null : (field.field.correct = column)
                          " class="radio-bg d-flex justify-content-center my-1">
                          <p-radioButton [disabled]="(disabled || (!isAssessment && !isTopic)) ? true : false"
                            [value]="column" [(ngModel)]="field.field.correct"></p-radioButton>
                        </div>
                      </div>
                      <!-- Row 1 section with radio buttons end -->
                    </div>
                  </div>
                </ng-container>
              </div>
            </section>
            <div class="d-flex flex-row gap-3 my-3">
              <div *ngIf="questionIndex == editingIndex && !disabled">
                <button [disabled]="disabled" (click)="addRow(question, '')" class="v4-btn-add">
                  <i class="pi pi-plus v4-ml-2"></i>{{ "Row" | translator }}
                </button>
              </div>
              <div *ngIf="questionIndex == editingIndex && !disabled">
                <button [disabled]="disabled" (click)="addColumn(question)" class="v4-btn-add">
                  <i class="pi pi-plus v4-ml-2"></i>{{ "Column" | translator }}
                </button>
              </div>
            </div>
          </div>
          <!-- Multi point Scale END -->
        </ng-container>
        <ng-container *ngSwitchCase="'MULTI_SELECT_SCALE'">
          <div class="flex-start my-3" *ngIf="(disabled && isConditional) || (disabled && isLinked)">
            <p-button (onClick)="unlockQuestion()" [pTooltip]="'Unlock Question & Edit' | translator"
              styleClass="input-button p-button-rounded p-button-danger p-button-text" icon="pi pi-lock"></p-button>
          </div>
          <div class="row" *ngIf="isAssessment && !UserExternalFields">
            <div class="col-md-6 col-12 d-flex gap-2 justify-content-start my-4">
              <p-button (onClick)="openServiceModal(question)" styleC="qbl-btn"
                label="{{ 'Select Service' | translator }}"></p-button>
              <ng-container *ngIf="question?.meta?.serviceIcon && question?.meta?.servicelabel">
                <div class="minisbutton d-flex gap-2">
                  <img src="{{ staticFileUrl + question?.meta?.serviceIcon }}" class="ministry-logo" />
                  <h5 class="miniheading">
                    {{ question?.meta?.servicelabel }}
                  </h5>
                </div>
                <p-button (onClick)="launchUrl(question.meta.service)" styleC="qbl-btn"
                  label="{{ 'Service' | translator }}" icon="pi pi-external-link"></p-button>
              </ng-container>
            </div>
          </div>
          <div class="input-with-button column flex-row"
            *ngIf="survey.topics != undefined && survey.topics.length > 0 && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{
                "ClassificationQue" | translator
                }}</span>

              <p-tree [value]="survey.topics" selectionMode="single" [(selection)]="question.meta.selectedTopic"
                emptyMessage="{{'No question classification created' | translator}}"
                (onNodeSelect)="toggleSelection($event)"></p-tree>

              <!-- p-dropdown [options]="survey.topics" [(selection)]="question.meta.selectedTopic"  [placeholder]="'Select Question Topics' | translator" ></p-dropdown -->
            </div>
          </div>
          <div class="input-with-button column flex-row" *ngIf="(isAssessment || isTopic) && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start" *ngIf="!fromTraining">
              <span class="ans-color">{{
                "Difficulty Level" | translator
                }}</span>
              <p-dropdown [options]="difficultyLevels" [(ngModel)]="question.meta.difficultyLevel"></p-dropdown>
            </div>
          </div>
          <div class="input-with-button column flex-row my-2" *ngIf="isAssessment && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Marks" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field" placeholder="{{ 'Marks' | translator }}"
                [disabled]="disabled" [inputStyle]="{
                                  'background-color': 'transparent',
                                  'border': 'none',
                                  'border-bottom': 'solid 1px lightgrey',
                                  'border-radius': '0px',
                                  'width': '100%',
                                  'color': 'white',
                              }" [(ngModel)]="question.meta.marks" />
            </div>
          </div>
          <div *ngIf="!UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Description" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.description" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div *ngIf="(isAssessment || isTopic) && !UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Feedback" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.feedback" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <!-- Multi Select -->
          <div class="column">
            <div class="input-with-button column flex-row my-4 "
              [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
              <input [disabled]="disabled" style="
                  background-color: transparent;
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                  color: white;
                " class="input-field 5" [placeholder]="question.meta.placeholder" [(ngModel)]="question.questionText"
                type="text" pInputText />
              <p-button [disabled]="disabled" styleClass="input-button p-button-rounded p-button-danger p-button-text"
                (onClick)="removeQuestion(questionIndex, UserExternalFields)" icon="pi pi-trash"></p-button>
            </div>
            <section>
              <div class="row">
                <!-- left right anchor section -->
                <div class="col-md-6 col-12 d-flex justify-content-start my-4" *ngIf="false">
                  <input [disabled]="disabled" style="
                      background-color: transparent;
                      border: none;
                      border-bottom: solid 1px lightgrey;
                      border-radius: 0px;
                      width: 200px;
                      color: white;
                    " class="input-field" [placeholder]="question.meta.rightAnchorPlaceholder"
                    [(ngModel)]="question.meta.rightAnchor" type="text" pInputText />
                </div>
                <div class="col-md-6 col-12 d-flex justify-content-start my-4" *ngIf="false">
                  <input [disabled]="disabled" style="
                      background-color: transparent;
                      border: none;
                      border-bottom: solid 1px lightgrey;
                      border-radius: 0px;
                      width: 200px;
                      color: white;
                    " class="input-field" [placeholder]="question.meta.leftAnchorPlaceholder"
                    [(ngModel)]="question.meta.leftAnchor" type="text" pInputText />
                </div>
                <!-- left right anchor section end -->

                <!-- column 1 or 2 section -->
                <div class="col-12 row">
                  <div class="col-md-4 col-12"></div>
                  <div *ngFor="
                      let column of question.meta.columnsPlaceholder;
                      let columnIndex = index
                    " class="col d-flex justify-content-start my-2">
                    <input [disabled]="disabled" style="
                        background-color: transparent;
                        border: none;
                        border-bottom: solid 1px lightgrey;
                        border-radius: 0px;
                        width: 100%;
                        color: white;
                      " class="input-field" type="text" [placeholder]="question.meta.columnsPlaceholder[columnIndex]"
                      [(ngModel)]="question.meta.columns[columnIndex]"
                      (change)="updateColumn(question, $event, columnIndex)" pInputText />
                    <p-button [disabled]="disabled" (onClick)="removeColumn(question, columnIndex)"
                      styleClass="p-button-rounded p-button-danger p-button-text" icon="pi pi-trash"></p-button>
                  </div>
                </div>
                <!-- column 1 or 2 section end -->

                <ng-container *ngFor="let field of question.meta.fields; let rowIndex = index">
                  <div class="col-12 row">
                    <!-- Row 1 section with radio buttons -->
                    <div class="col-md-4 col-12">
                      <input [disabled]="disabled" style="
                          background-color: transparent;
                          border: none;
                          border-bottom: solid 1px lightgrey;
                          border-radius: 0px;
                          width: 100%;
                          color: white;
                        " class="input-field" [placeholder]="field.field.placeholder" [(ngModel)]="field.field.label"
                        type="text" pInputText />
                    </div>
                    <div class="col-auto mt-1">
                      <p-button [disabled]="disabled" (onClick)="removeRow(question, rowIndex)"
                        styleClass="p-button-rounded p-button-danger p-button-text" icon="pi pi-trash"></p-button>
                    </div>
                    <div class="col d-flex align-items-start" *ngFor="let column of question.meta.columnsPlaceholder">
                      <div style="cursor: pointer" class="radio-bg d-flex justify-content-center my-1">
                        <p-checkbox class="v4-color-white" name="{{ field.field.label }}" [value]="column"
                          [disabled]="(disabled || (!isAssessment && !isTopic)) ? true : false"
                          [(ngModel)]="field.correct"></p-checkbox>
                      </div>
                    </div>
                    <!-- Row 1 section with radio buttons end -->
                  </div>
                </ng-container>
              </div>
            </section>
            <div class="d-flex flex-row gap-3 my-3">
              <div *ngIf="questionIndex == editingIndex && !disabled">
                <button [disabled]="disabled" (click)="addRow(question, [])" class="v4-btn-add">
                  <i class="pi pi-plus v4-ml-2"></i>{{ "Row" | translator }}
                </button>
              </div>
              <div *ngIf="questionIndex == editingIndex && !disabled">
                <button [disabled]="disabled" (click)="addColumn(question)" class="v4-btn-add">
                  <i class="pi pi-plus v4-ml-2"></i>{{ "Column" | translator }}
                </button>
              </div>
            </div>
          </div>
          <!-- Multi Select END -->
        </ng-container>
        <ng-container *ngSwitchCase="'RANK_ORDER'">
          <div class="flex-start my-3" *ngIf="(disabled && isConditional) || (disabled && isLinked)">
            <p-button (onClick)="unlockQuestion()" [pTooltip]="'Unlock Question & Edit' | translator"
              styleClass="input-button p-button-rounded p-button-danger p-button-text" icon="pi pi-lock"></p-button>
          </div>
          <div class="row" *ngIf="isAssessment && !UserExternalFields">
            <div class="col-md-6 col-12 d-flex gap-2 justify-content-start my-4">
              <p-button (onClick)="openServiceModal(question)" styleC="qbl-btn"
                label="{{ 'Select Service' | translator }}"></p-button>
              <ng-container *ngIf="question?.meta?.serviceIcon && question?.meta?.servicelabel">
                <div class="minisbutton d-flex gap-2">
                  <img src="{{ staticFileUrl + question?.meta?.serviceIcon }}" class="ministry-logo" />
                  <h5 class="miniheading">
                    {{ question?.meta?.servicelabel }}
                  </h5>
                </div>
                <p-button (onClick)="launchUrl(question.meta.service)" styleC="qbl-btn"
                  label="{{ 'Service' | translator }}" icon="pi pi-external-link"></p-button>
              </ng-container>
            </div>
          </div>
          <div class="input-with-button column flex-row"
            *ngIf="survey.topics != undefined && survey.topics.length > 0 && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{
                "ClassificationQue" | translator
                }}</span>
              <!-- p-dropdown [options]="survey.topics" [(selection)]="question.meta.selectedTopic"  [placeholder]="'Select Question Topics' | translator" ></p-dropdown -->

              <p-tree [value]="survey.topics" selectionMode="single" [(selection)]="question.meta.selectedTopic"
                emptyMessage="{{'No question classification created' | translator}}"
                (onNodeSelect)="toggleSelection($event)"></p-tree>
            </div>
          </div>
          <div class="input-with-button column flex-row" *ngIf="(isAssessment || isTopic) && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start" *ngIf="!fromTraining">
              <span class="ans-color">{{
                "Difficulty Level" | translator
                }}</span>
              <p-dropdown [options]="difficultyLevels" [(ngModel)]="question.meta.difficultyLevel"></p-dropdown>
            </div>
          </div>
          <div class="input-with-button column flex-row my-2" *ngIf="isAssessment && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Marks" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field" placeholder="{{ 'Marks' | translator }}"
                [disabled]="disabled" [inputStyle]="{
                                  'background-color': 'transparent',
                                  'border': 'none',
                                  'border-bottom': 'solid 1px lightgrey',
                                  'border-radius': '0px',
                                  'width': '100%',
                                  'color': 'white',
                              }" [(ngModel)]="question.meta.marks" />
            </div>
          </div>
          <div *ngIf="!UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Description" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.description" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div *ngIf="(isAssessment || isTopic) && !UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Feedback" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.feedback" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <!-- Rank Order -->
          <div class="column">
            <div class="input-with-button column flex-row my-4 "
              [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
              <input [disabled]="disabled" style="
                  background-color: transparent;
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                  color: white;
                " class="input-field 6" [placeholder]="question.meta.placeholder" [(ngModel)]="question.questionText"
                type="text" pInputText />
              <p-button [disabled]="disabled" *ngIf="editingIndex == questionIndex"
                styleClass="input-button p-button-rounded p-button-danger p-button-text"
                (onClick)="removeQuestion(questionIndex, UserExternalFields)" icon="pi pi-trash"></p-button>
            </div>
            <div class="my-3">
              <div class="d-flex flex-wrap my-1" *ngFor="
                  let field of question.meta.fields;
                  let fieldIndex = index
                ">
                <div>
                  <input [disabled]="disabled" style="
                      background-color: transparent;
                      border: none;
                      border-bottom: solid 1px lightgrey;
                      border-radius: 0px;
                      width: 100%;
                      color: white;
                    " class="input-field" [placeholder]="field.placeholder" 
                  [(ngModel)]="field.label"
                  (focus)="storeOldValue(field)"
                  (ngModelChange)="onLabelChange(field, $event)" type="text"
                    pInputText />
                </div>
                <div class="brdr-btm mx-2">
                  <p-dropdown [disabled]="disabled" placeholder="{{ '-Select-' | translator }}"
                    (ngModelChange)="getRankDDValues(question)" [(ngModel)]="field.correct"
                    [options]="getRankDDValues(question)"></p-dropdown>
                </div>
                <p-button [disabled]="disabled" *ngIf="questionIndex == editingIndex && !disabled" (click)="
                    removeRowInTextInput(question, fieldIndex, questionIndex)
                  " styleClass="input-button p-button-rounded p-button-danger p-button-text"
                  icon="pi pi-trash"></p-button>
              </div>
            </div>
            <div class="col-md-12 col-12 my-2" *ngIf="questionIndex == editingIndex && !disabled">
              <p-button class="v4-plus" [disabled]="disabled" (onClick)="addRowInTextInput(question, questionIndex)"
                icon="pi pi-plus" styleClass="p-button-rounded p-button-outlined"></p-button>
            </div>
          </div>
          <!-- Rank Order End -->
        </ng-container>
        <ng-container *ngSwitchCase="'DRAG_DROP'">
          <div class="flex-start my-3" *ngIf="(disabled && isConditional) || (disabled && isLinked)">
            <p-button (onClick)="unlockQuestion()" [pTooltip]="'Unlock Question & Edit' | translator"
              styleClass="input-button p-button-rounded p-button-danger p-button-text" icon="pi pi-lock"></p-button>
          </div>
          <div class="row" *ngIf="isAssessment && !UserExternalFields">
            <div class="col-md-6 col-12 d-flex gap-2 justify-content-start my-4">
              <p-button (onClick)="openServiceModal(question)" styleC="qbl-btn"
                label="{{ 'Select Service' | translator }}"></p-button>
              <ng-container *ngIf="question?.meta?.serviceIcon && question?.meta?.servicelabel">
                <div class="minisbutton d-flex gap-2">
                  <img src="{{ staticFileUrl + question?.meta?.serviceIcon }}" class="ministry-logo" />
                  <h5 class="miniheading">
                    {{ question?.meta?.servicelabel }}
                  </h5>
                </div>
                <p-button (onClick)="launchUrl(question.meta.service)" styleC="qbl-btn"
                  label="{{ 'Service' | translator }}" icon="pi pi-external-link"></p-button>
              </ng-container>
            </div>
          </div>
          <div class="input-with-button column flex-row"
            *ngIf="survey.topics != undefined && survey.topics.length > 0 && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{
                "ClassificationQue" | translator
                }}</span>
              <!-- p-dropdown [options]="survey.topics" [(selection)]="question.meta.selectedTopic"  [placeholder]="'Select Question Topics' | translator" ></p-dropdown -->

              <p-tree [value]="survey.topics" selectionMode="single" [(selection)]="question.meta.selectedTopic"
                emptyMessage="{{'No question classification created' | translator}}"
                (onNodeSelect)="toggleSelection($event)"></p-tree>
            </div>
          </div>
          <div class="input-with-button column flex-row" *ngIf="(isAssessment || isTopic) && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start" *ngIf="!fromTraining">
              <span class="ans-color">{{
                "Difficulty Level" | translator
                }}</span>
              <p-dropdown [options]="difficultyLevels" [(ngModel)]="question.meta.difficultyLevel"></p-dropdown>
            </div>
          </div>
          <div class="input-with-button column flex-row my-2" *ngIf="isAssessment && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Marks" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field" placeholder="{{ 'Marks' | translator }}"
                [disabled]="disabled" [inputStyle]="{
                                  'background-color': 'transparent',
                                  'border': 'none',
                                  'border-bottom': 'solid 1px lightgrey',
                                  'border-radius': '0px',
                                  'width': '100%',
                                  'color': 'white',
                              }" [(ngModel)]="question.meta.marks" />
            </div>
          </div>
          <div *ngIf="!UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Description" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.description" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div *ngIf="(isAssessment || isTopic) && !UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Feedback" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.feedback" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <!-- Drag and Drop -->
          <div class="column">
            <div class="input-with-button column flex-row my-4 "
              [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
              <input [disabled]="disabled" style="
                  background-color: transparent;
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                  color: white;
                " class="input-field 7" [placeholder]="question.meta.placeholder" [(ngModel)]="question.questionText"
                type="text" pInputText />
              <p-button [disabled]="disabled" styleClass="input-button p-button-rounded p-button-danger p-button-text"
                (onClick)="removeQuestion(questionIndex, UserExternalFields)" icon="pi pi-trash"></p-button>
            </div>
            <div class="my-4 row" style="flex-wrap:nowrap">
              <div class="col-md-8">
                <div class="d-flex flex-row flex-wrap align-items-center my-3" *ngFor="
                    let field of question.meta.fields;
                    let fieldIndex = index
                  ">
                  <div class="width-170px square">
                    <div class="d-flex justify-content-between align-items-center">
                      <span>
                        <input [disabled]="disabled" style="
                            background-color: transparent;
                            border: none;
                            border-bottom: solid 1px lightgrey;
                            border-radius: 0px;
                            width: 100%;
                            color: white;
                          " class="input-field" [placeholder]="field.placeholder" 
                  [(ngModel)]="field.label"
                  (focus)="storeOldValue(field)"
                  (ngModelChange)="onLabelChange(field, $event)" type="text"
                          pInputText />
                      </span>
                      <span class="circle-num">
                        {{ field.order }}
                      </span>
                    </div>
                  </div>
                  <div class="brdr-btm mx-2">
                    <p-dropdown [disabled]="disabled" placeholder="{{ '-Select-' | translator }}"
                      (ngModelChange)="getRankDDValues(question)" [(ngModel)]="field.correct"
                      [options]="getRankDDValues(question)"></p-dropdown>
                  </div>
                  <p-button [disabled]="disabled" *ngIf="questionIndex == editingIndex && !disabled" (click)="
                      removeRowInTextInput(question, fieldIndex, questionIndex)
                    " styleClass="input-button p-button-rounded p-button-danger p-button-text"
                    icon="pi pi-trash"></p-button>
                </div>
              </div>
              <div class="col-md-4 width-200px mx-5">
                <input [disabled]="disabled" style="
                    background-color: transparent;
                    border: none;
                    border-bottom: solid 1px lightgrey;
                    border-radius: 0px;
                    width: 100%;
                    color: white;
                  " class="input-field mx-2" [placeholder]="question.meta.topAnchorPlaceholder"
                  [(ngModel)]="question.meta.topAnchor" type="text" pInputText />
                <input [disabled]="disabled" style="
                    background-color: transparent;
                    border: none;
                    border-bottom: solid 1px lightgrey;
                    border-radius: 0px;
                    width: 100%;
                    color: white;
                  " class="input-field" [placeholder]="question.meta.bottomAnchorPlaceholder"
                  [(ngModel)]="question.meta.bottomAnchor" type="text" pInputText />
              </div>
            </div>
            <div class="col-md-12 col-12 my-2" *ngIf="questionIndex == editingIndex && !disabled">
              <p-button class="v4-plus" [disabled]="disabled" (onClick)="addFieldWithOrder(question)" icon="pi pi-plus"
                styleClass="p-button-rounded p-button-outlined"></p-button>
            </div>
          </div>
          <!-- Drag and Drop End -->
        </ng-container>
        <ng-container *ngSwitchCase="'DATE_TIME'">
          <div class="flex-start my-3" *ngIf="(disabled && isConditional) || (disabled && isLinked)">
            <p-button (onClick)="unlockQuestion()" [pTooltip]="'Unlock Question & Edit' | translator"
              styleClass="input-button p-button-rounded p-button-danger p-button-text" icon="pi pi-lock"></p-button>
          </div>
          <div class="row" *ngIf="isAssessment && !UserExternalFields">
            <div class="col-md-6 col-12 d-flex gap-2 justify-content-start my-4">
              <p-button (onClick)="openServiceModal(question)" styleC="qbl-btn"
                label="{{ 'Select Service' | translator }}"></p-button>
              <ng-container *ngIf="question?.meta?.serviceIcon && question?.meta?.servicelabel">
                <div class="minisbutton d-flex gap-2">
                  <img src="{{ staticFileUrl + question?.meta?.serviceIcon }}" class="ministry-logo" />
                  <h5 class="miniheading">
                    {{ question?.meta?.servicelabel }}
                  </h5>
                </div>
                <p-button (onClick)="launchUrl(question.meta.service)" styleC="qbl-btn"
                  label="{{ 'Service' | translator }}" icon="pi pi-external-link"></p-button>
              </ng-container>
            </div>
          </div>
          <div class="input-with-button column flex-row"
            *ngIf="survey.topics != undefined && survey.topics.length > 0 && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{
                "ClassificationQue" | translator
                }}</span>
              <!-- p-dropdown [options]="survey.topics" [(selection)]="question.meta.selectedTopic"  [placeholder]="'Select Question Topics' | translator" ></p-dropdown -->

              <p-tree [value]="survey.topics" selectionMode="single" [(selection)]="question.meta.selectedTopic"
                emptyMessage="{{'No question classification created' | translator}}"
                (onNodeSelect)="toggleSelection($event)"></p-tree>
            </div>
          </div>
          <div class="input-with-button column flex-row" *ngIf="(isAssessment || isTopic) && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start" *ngIf="!fromTraining">
              <span class="ans-color">{{
                "Difficulty Level" | translator
                }}</span>
              <p-dropdown [options]="difficultyLevels" [(ngModel)]="question.meta.difficultyLevel"></p-dropdown>
            </div>
          </div>
          <div class="input-with-button column flex-row my-2" *ngIf="isAssessment && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Marks" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field" placeholder="{{ 'Marks' | translator }}"
                [disabled]="disabled" [inputStyle]="{
                                  'background-color': 'transparent',
                                  'border': 'none',
                                  'border-bottom': 'solid 1px lightgrey',
                                  'border-radius': '0px',
                                  'width': '100%',
                                  'color': 'white',
                              }" [(ngModel)]="question.meta.marks" />
            </div>
          </div>
          <div *ngIf="!UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Description" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.description" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div *ngIf="(isAssessment || isTopic) && !UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Feedback" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.feedback" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <!-- Date of birth -->
          <div class="column my-2">
            <div class="input-with-button column flex-row my-4 "
              [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
              <input [disabled]="disabled" style="
                  background-color: transparent;
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                  color: white;
                " class="input-field 8" [placeholder]="question.meta.placeholder" [(ngModel)]="question.questionText"
                type="text" pInputText />
              <p-button [disabled]="disabled" *ngIf="editingIndex == questionIndex"
                styleClass="input-button p-button-rounded p-button-danger p-button-text"
                (onClick)="removeQuestion(questionIndex, UserExternalFields)" icon="pi pi-trash"></p-button>
            </div>
            <div class="my-3">
              <!-- <label for="day">Day:</label> -->
              <select [disabled]="disabled" [(ngModel)]="question.meta.correct.day" disabled id="day" name="day"
                class="dob-select m-1">
                <option value="">{{'Day' | translator}}</option>
                <option *ngFor="let day of days" value="{{ day }}">
                  {{ day }}
                </option>
              </select>

              <!-- <label for="month">Month:</label> -->
              <select [disabled]="disabled" [(ngModel)]="question.meta.correct.month" disabled id="month" name="month"
                class="dob-select m-1">
                <option value="">{{'Month' | translator}}</option>
                <option *ngFor="let month of months" value="{{ month }}">
                  {{ month }}
                </option>
              </select>

              <!-- <label for="year">Year:</label> -->
              <select [disabled]="disabled" [(ngModel)]="question.meta.correct.year" disabled id="year" name="year"
                class="dob-select m-1">
                <option value="">{{'Year' | translator }}</option>
                <option *ngFor="let year of years" value="{{ year }}">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
          <!-- Date of birth END -->
        </ng-container>
        <ng-container *ngSwitchCase="'CALENDAR'">
          <div class="flex-start my-3" *ngIf="(disabled && isConditional) || (disabled && isLinked)">
            <p-button (onClick)="unlockQuestion()" [pTooltip]="'Unlock Question & Edit' | translator"
              styleClass="input-button p-button-rounded p-button-danger p-button-text" icon="pi pi-lock"></p-button>
          </div>
          <div class="row" *ngIf="isAssessment && !UserExternalFields">
            <div class="col-md-6 col-12 d-flex gap-2 justify-content-start my-4">
              <p-button (onClick)="openServiceModal(question)" styleC="qbl-btn"
                label="{{ 'Select Service' | translator }}"></p-button>
              <ng-container *ngIf="question?.meta?.serviceIcon && question?.meta?.servicelabel">
                <div class="minisbutton d-flex gap-2">
                  <img src="{{ staticFileUrl + question?.meta?.serviceIcon }}" class="ministry-logo" />
                  <h5 class="miniheading">
                    {{ question?.meta?.servicelabel }}
                  </h5>
                </div>
                <p-button (onClick)="launchUrl(question.meta.service)" styleC="qbl-btn"
                  label="{{ 'Service' | translator }}" icon="pi pi-external-link"></p-button>
              </ng-container>
            </div>
          </div>
          <div class="input-with-button column flex-row"
            *ngIf="survey.topics != undefined && survey.topics.length > 0 && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{
                "ClassificationQue" | translator
                }}</span>
              <!-- p-dropdown [options]="survey.topics" [(selection)]="question.meta.selectedTopic"  [placeholder]="'Select Question Topics' | translator" ></p-dropdown -->

              <p-tree [value]="survey.topics" selectionMode="single" [(selection)]="question.meta.selectedTopic"
                emptyMessage="{{'No question classification created' | translator}}"
                (onNodeSelect)="toggleSelection($event)"></p-tree>
            </div>
          </div>
          <div class="input-with-button column flex-row" *ngIf="(isAssessment || isTopic) && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start" *ngIf="!fromTraining">
              <span class="ans-color">{{
                "Difficulty Level" | translator
                }}</span>
              <p-dropdown [options]="difficultyLevels" [(ngModel)]="question.meta.difficultyLevel"></p-dropdown>
            </div>
          </div>
          <div class="input-with-button column flex-row my-2" *ngIf="isAssessment && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Marks" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field" placeholder="{{ 'Marks' | translator }}"
                [disabled]="disabled" [inputStyle]="{
                                  'background-color': 'transparent',
                                  'border': 'none',
                                  'border-bottom': 'solid 1px lightgrey',
                                  'border-radius': '0px',
                                  'width': '100%',
                                  'color': 'white',
                              }" [(ngModel)]="question.meta.marks" />
            </div>
          </div>
          <div *ngIf="!UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Description" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.description" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div *ngIf="(isAssessment || isTopic) && !UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Feedback" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.feedback" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <!-- Calander -->
          <div class="column my-2">
            <div class="input-with-button column flex-row my-4 "
              [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
              <input [disabled]="disabled" style="
                  background-color: transparent;
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                  color: white;
                " class="input-field 9" [placeholder]="question.meta.placeholder" [(ngModel)]="question.questionText"
                type="text" pInputText />
              <p-button [disabled]="disabled" *ngIf="editingIndex == questionIndex"
                styleClass="input-button p-button-rounded p-button-danger p-button-text"
                (onClick)="removeQuestion(questionIndex, UserExternalFields)" icon="pi pi-trash"></p-button>
            </div>
            <div class="d-flex">
              <div class="d-flex my-3">
                <p-calendar dir="ltr" [disabled]="disabled" appendTo="body" [(ngModel)]="question.meta.correct"
                  [placeholder]="getDatePlaceholder(question.meta.correct)" [showIcon]="true"></p-calendar>
              </div>
            </div>
          </div>
          <!-- Calander END -->
        </ng-container>
        <ng-container *ngSwitchCase="'PRESENTATION_TEXT'">
          <!-- Presentation Text -->
          <div class="column my-2">
            <div class="input-with-button column flex-row my-4 "
              [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
              <input [disabled]="disabled" style="
                  background-color: transparent;
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                  color: white;
                " class="input-field" [placeholder]="question.meta.placeholder" [(ngModel)]="question.questionText"
                type="text" pInputText />
              <p-button [disabled]="disabled" *ngIf="editingIndex == questionIndex"
                styleClass="input-button p-button-rounded p-button-danger p-button-text"
                (onClick)="removeQuestion(questionIndex, UserExternalFields)" icon="pi pi-trash"></p-button>
            </div>
          </div>
          <!-- Presentation Text END -->
        </ng-container>
        <ng-container *ngSwitchCase="'SECTION_HEADING'">
          <!-- Section Heading -->
          <div class="column my-2">
            <div class="input-with-button column flex-row my-4 "
              [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
              <input [disabled]="disabled" style="
                  background: rgb(112, 112, 177);
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                  color: white;
                " class="input-field text-light" [placeholder]="question.meta.placeholder"
                [(ngModel)]="question.questionText" type="text" pInputText />
              <p-button [disabled]="disabled" *ngIf="editingIndex == questionIndex"
                styleClass="input-button p-button-rounded p-button-danger p-button-text"
                (onClick)="removeQuestion(questionIndex, UserExternalFields)" icon="pi pi-trash"></p-button>
            </div>
          </div>
          <!-- Section Heading END -->
        </ng-container>
        <ng-container *ngSwitchCase="'SECTION_SUB_HEADING'">
          <!-- Section Sub-Heading -->
          <div class="column my-2">
            <div class="input-with-button column flex-row my-4 "
              [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
              <input [disabled]="disabled" style="
                  background-color: transparent;
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                  color: white;
                " class="input-field" [placeholder]="question.meta.placeholder" [(ngModel)]="question.questionText"
                type="text" pInputText />
              <p-button [disabled]="disabled" *ngIf="questionIndex == editingIndex && !disabled"
                styleClass="input-button p-button-rounded p-button-danger p-button-text"
                (onClick)="removeQuestion(questionIndex, UserExternalFields)" icon="pi pi-trash"></p-button>
            </div>
          </div>
          <!-- Section Sub-Heading END -->
        </ng-container>
        <ng-container *ngSwitchCase="'DYNAMIC_MESSAGE'">
          <!-- DYNAMIC_MESSAGE -->
          <div class="column my-2">
            <div class="input-with-button column flex-row my-4 align-items-center "
              [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
              <p-editor [disabled]="disabled" [(ngModel)]="question.questionText" class="w-100"
                [style]="{ height: '100px' }"></p-editor>
              <p-button [disabled]="disabled" *ngIf="editingIndex == questionIndex"
                styleClass="input-button p-button-rounded p-button-danger p-button-text"
                (onClick)="removeQuestion(questionIndex, UserExternalFields)" icon="pi pi-trash"></p-button>
            </div>
          </div>
          <!-- DYNAMIC_MESSAGE END -->
        </ng-container>
        <ng-container *ngSwitchCase="'STAR_RATING'">
          <div class="flex-start my-3" *ngIf="(disabled && isConditional) || (disabled && isLinked)">
            <p-button (onClick)="unlockQuestion()" [pTooltip]="'Unlock Question & Edit' | translator"
              styleClass="input-button p-button-rounded p-button-danger p-button-text" icon="pi pi-lock"></p-button>
          </div>
          <div class="row" *ngIf="isAssessment && !UserExternalFields">
            <div class="col-md-6 col-12 d-flex gap-2 justify-content-start my-4">
              <p-button (onClick)="openServiceModal(question)" styleC="qbl-btn"
                label="{{ 'Select Service' | translator }}"></p-button>
              <ng-container *ngIf="question?.meta?.serviceIcon && question?.meta?.servicelabel">
                <div class="minisbutton d-flex gap-2">
                  <img src="{{ staticFileUrl + question?.meta?.serviceIcon }}" class="ministry-logo" />
                  <h5 class="miniheading">
                    {{ question?.meta?.servicelabel }}
                  </h5>
                </div>
                <p-button (onClick)="launchUrl(question.meta.service)" styleC="qbl-btn"
                  label="{{ 'Service' | translator }}" icon="pi pi-external-link"></p-button>
              </ng-container>
            </div>
          </div>
          <div class="input-with-button column flex-row"
            *ngIf="survey.topics != undefined && survey.topics.length > 0 && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{
                "ClassificationQue" | translator
                }}</span>
              <!-- p-dropdown [options]="survey.topics" [(selection)]="question.meta.selectedTopic"  [placeholder]="'Select Question Topics' | translator" ></p-dropdown -->

              <p-tree [value]="survey.topics" selectionMode="single" [(selection)]="question.meta.selectedTopic"
                emptyMessage="{{'No question classification created' | translator}}"
                (onNodeSelect)="toggleSelection($event)"></p-tree>
            </div>
          </div>
          <div class="input-with-button column flex-row" *ngIf="(isAssessment || isTopic) && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start" *ngIf="!fromTraining">
              <span class="ans-color">{{
                "Difficulty Level" | translator
                }}</span>
              <p-dropdown [options]="difficultyLevels" [(ngModel)]="question.meta.difficultyLevel"></p-dropdown>
            </div>
          </div>
          <div class="input-with-button column flex-row my-2" *ngIf="isAssessment && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Marks" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field" placeholder="{{ 'Marks' | translator }}"
                [disabled]="disabled" [inputStyle]="{
                                  'background-color': 'transparent',
                                  'border': 'none',
                                  'border-bottom': 'solid 1px lightgrey',
                                  'border-radius': '0px',
                                  'width': '100%',
                                  'color': 'white',
                              }" [(ngModel)]="question.meta.marks" />
            </div>
          </div>
          <div *ngIf="!UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Description" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.description" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div *ngIf="(isAssessment || isTopic) && !UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Feedback" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.feedback" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <!-- star Rating -->
          <div class="column">
            <div class="input-with-button column flex-row my-4 "
              [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
              <input [disabled]="disabled" style="
                  background-color: transparent;
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                  color: white;
                " class="input-field 10" [placeholder]="question.meta.placeholder" [(ngModel)]="question.questionText"
                type="text" pInputText />
              <p-button [disabled]="disabled" *ngIf="questionIndex == editingIndex && !disabled"
                styleClass="input-button p-button-rounded p-button-danger p-button-text"
                (onClick)="removeQuestion(questionIndex, UserExternalFields)" icon="pi pi-trash"></p-button>
            </div>

            <div class="row w-100">
              <div class="row w-100" *ngFor="
                  let field of question.meta.fields;
                  let fieldIndex = index
                ">
                <div class="col-md-4 col-12 my-2">
                  <input [disabled]="disabled" style="
                      background-color: transparent;
                      border: none;
                      border-bottom: solid 1px lightgrey;
                      border-radius: 0px;
                      width: 100%;
                      color: white;
                    " class="input-field" [placeholder]="field.placeholder" 
                  [(ngModel)]="field.label"
                  (focus)="storeOldValue(field)"
                  (ngModelChange)="onLabelChange(field, $event)" type="text"
                    pInputText />
                </div>
                <div class="col-md-8 col-12 d-flex align-items-end my-2">
                  <p-rating [disabled]="disabled" [(ngModel)]="field.correct" [cancel]="false"></p-rating>
                </div>
                <div class="col-md-4 col-12 d-flex align-items-end">
                  <p-button [disabled]="disabled" *ngIf="questionIndex == editingIndex && !disabled" (click)="
                      removeRowInTextInput(question, fieldIndex, questionIndex)
                    " styleClass="input-button p-button-rounded p-button-danger p-button-text"
                    icon="pi pi-trash"></p-button>
                </div>
              </div>
              <div class="col-md-12 col-12 my-2" *ngIf="questionIndex == editingIndex && !disabled">
                <p-button class="v4-plus" [disabled]="disabled" (onClick)="addRowInTextInput(question, questionIndex)"
                  icon="pi pi-plus" styleClass="p-button-rounded p-button-outlined"></p-button>
              </div>
            </div>
          </div>
          <!-- star Rating End -->
        </ng-container>
        <ng-container *ngSwitchCase="'SELECT_MANY'">
          <div class="flex-start my-3" *ngIf="(disabled && isConditional) || (disabled && isLinked)">
            <p-button (onClick)="unlockQuestion()" [pTooltip]="'Unlock Question & Edit' | translator"
              styleClass="input-button p-button-rounded p-button-danger p-button-text" icon="pi pi-lock"></p-button>
          </div>
          <div class="row" *ngIf="isAssessment && !UserExternalFields">
            <div class="col-md-6 col-12 d-flex gap-2 justify-content-start my-4">
              <p-button (onClick)="openServiceModal(question)" styleC="qbl-btn"
                label="{{ 'Select Service' | translator }}"></p-button>
              <ng-container *ngIf="question?.meta?.serviceIcon && question?.meta?.servicelabel">
                <div class="minisbutton d-flex gap-2">
                  <img src="{{ staticFileUrl + question?.meta?.serviceIcon }}" class="ministry-logo" />
                  <h5 class="miniheading">
                    {{ question?.meta?.servicelabel }}
                  </h5>
                </div>
                <p-button (onClick)="launchUrl(question.meta.service)" styleC="qbl-btn"
                  label="{{ 'Service' | translator }}" icon="pi pi-external-link"></p-button>
              </ng-container>
            </div>
          </div>
          <div class="input-with-button column flex-row"
            *ngIf="survey.topics != undefined && survey.topics.length > 0 && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{
                "ClassificationQue" | translator
                }}</span>
              <!-- p-dropdown [options]="survey.topics" [(selection)]="question.meta.selectedTopic"  [placeholder]="'Select Question Topics' | translator" ></p-dropdown -->

              <p-tree [value]="survey.topics" selectionMode="single" [(selection)]="question.meta.selectedTopic"
                emptyMessage="{{'No question classification created' | translator}}"
                (onNodeSelect)="toggleSelection($event)"></p-tree>
            </div>
          </div>
          <div class="input-with-button column flex-row" *ngIf="(isAssessment || isTopic) && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start" *ngIf="!fromTraining">
              <span class="ans-color">{{
                "Difficulty Level" | translator
                }}</span>
              <p-dropdown [options]="difficultyLevels" [(ngModel)]="question.meta.difficultyLevel"></p-dropdown>
            </div>
          </div>
          <div class="input-with-button column flex-row my-2" *ngIf="isAssessment && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Marks" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field" placeholder="{{ 'Marks' | translator }}"
                [disabled]="disabled" [inputStyle]="{
                                  'background-color': 'transparent',
                                  'border': 'none',
                                  'border-bottom': 'solid 1px lightgrey',
                                  'border-radius': '0px',
                                  'width': '100%',
                                  'color': 'white',
                              }" [(ngModel)]="question.meta.marks" />
            </div>
          </div>
          <div *ngIf="!UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Description" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.description" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div *ngIf="(isAssessment || isTopic) && !UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Feedback" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.feedback" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div class="column">
            <div class="input-with-button column flex-row my-4 "
              [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
              <input [disabled]="disabled" style="
                  background-color: transparent;
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                  color: white;
                " class="input-field 11" [placeholder]="question.meta.placeholder" [(ngModel)]="question.questionText"
                type="text" pInputText />
              <p-button [disabled]="disabled" styleClass="input-button p-button-rounded p-button-danger p-button-text"
                (onClick)="removeQuestion(questionIndex, UserExternalFields)" icon="pi pi-trash"></p-button>
            </div>
            <div class="d-flex justify-content-start">
              <div class="d-flex column my-4">
                <div class="column" *ngFor="
                    let field of question.meta.fields;
                    let fieldIndex = index
                  ">
                  <div class="d-flex my-1 align-items-center justify-content-start">
                    <p-checkbox class="v4-color-white" [disabled]="(field.label == '') ? true : disabled"
                      *ngIf="isAssessment || isTopic; else surveyTemplate" [name]="question.questionText"
                      (ngModelChange)="print($event)" [(ngModel)]="question.meta.correct"
                      [value]="field.label"></p-checkbox>
                    <ng-template #surveyTemplate>
                      <span class="pi pi-stop"></span>
                    </ng-template>
                    <input [disabled]="disabled" style="
                        background-color: transparent;
                        border: none;
                        border-bottom: solid 1px lightgrey;
                        border-radius: 0px;
                        width: 100%;
                        color: white;
                      " class="input-field" [placeholder]="field.placeholder" 
                  [(ngModel)]="field.label"
                  (focus)="storeOldValue(field)"
                  (ngModelChange)="onLabelChange(field, $event)" type="text"
                      pInputText />
                    <p-button [disabled]="disabled" *ngIf="questionIndex == editingIndex && !disabled" (click)="
                        removeRowInTextInput(
                          question,
                          fieldIndex,
                          questionIndex
                        )
                      " styleClass="input-button p-button-rounded p-button-danger p-button-text"
                      icon="pi pi-trash"></p-button>
                  </div>
                </div>
              </div>
            </div>
            <p-button class="v4-plus" [disabled]="disabled" (onClick)="addRowInTextInput(question, questionIndex)"
              icon="pi pi-plus" styleClass="p-button-rounded p-button-outlined"></p-button>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'COMMENT_BOX'">
          <div class="flex-start my-3" *ngIf="(disabled && isConditional) || (disabled && isLinked)">
            <p-button (onClick)="unlockQuestion()" [pTooltip]="'Unlock Question & Edit' | translator"
              styleClass="input-button p-button-rounded p-button-danger p-button-text" icon="pi pi-lock"></p-button>
          </div>
          <div class="row" *ngIf="isAssessment && !UserExternalFields">
            <div class="col-md-6 col-12 d-flex gap-2 justify-content-start my-4">
              <p-button (onClick)="openServiceModal(question)" styleC="qbl-btn"
                label="{{ 'Select Service' | translator }}"></p-button>
              <ng-container *ngIf="question?.meta?.serviceIcon && question?.meta?.servicelabel">
                <div class="minisbutton d-flex gap-2">
                  <img src="{{ staticFileUrl + question?.meta?.serviceIcon }}" class="ministry-logo" />
                  <h5 class="miniheading">
                    {{ question?.meta?.servicelabel }}
                  </h5>
                </div>
                <p-button (onClick)="launchUrl(question.meta.service)" styleC="qbl-btn"
                  label="{{ 'Service' | translator }}" icon="pi pi-external-link"></p-button>
              </ng-container>
            </div>
          </div>
          <div class="input-with-button column flex-row"
            *ngIf="survey.topics != undefined && survey.topics.length > 0 && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{
                "ClassificationQue" | translator
                }}</span>
              <!-- p-dropdown [options]="survey.topics" [(selection)]="question.meta.selectedTopic"  [placeholder]="'Select Question Topics' | translator" ></p-dropdown -->

              <p-tree [value]="survey.topics" selectionMode="single" [(selection)]="question.meta.selectedTopic"
                emptyMessage="{{'No question classification created' | translator}}"
                (onNodeSelect)="toggleSelection($event)"></p-tree>
            </div>
          </div>
          <div class="input-with-button column flex-row" *ngIf="(isAssessment || isTopic) && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start" *ngIf="!fromTraining">
              <span class="ans-color">{{
                "Difficulty Level" | translator
                }}</span>
              <p-dropdown [options]="difficultyLevels" [(ngModel)]="question.meta.difficultyLevel"></p-dropdown>
            </div>
          </div>
          <div class="input-with-button column flex-row my-2" *ngIf="isAssessment && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Marks" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field" placeholder="{{ 'Marks' | translator }}"
                [disabled]="disabled" [inputStyle]="{
                                  'background-color': 'transparent',
                                  'border': 'none',
                                  'border-bottom': 'solid 1px lightgrey',
                                  'border-radius': '0px',
                                  'width': '100%',
                                  'color': 'white',
                              }" [(ngModel)]="question.meta.marks" />
            </div>
          </div>
          <div *ngIf="!UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Description" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.description" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div *ngIf="(isAssessment || isTopic) && !UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Feedback" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.feedback" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div>
            <div class="column" *ngFor="let field of question.meta.fields; let fieldIndex = index">
              <div class="input-with-button column flex-row my-4 "
                [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
                <input [disabled]="disabled" style="
                    background-color: transparent;
                    border: none;
                    border-bottom: solid 1px lightgrey;
                    border-radius: 0px;
                    width: 100%;
                    color: white;
                  " class="input-field 12" [placeholder]="field.placeholder" 
                  [(ngModel)]="field.label"
                  (focus)="storeOldValue(field)"
                  (ngModelChange)="onLabelChange(field, $event)" type="text"
                  pInputText />
                <p-button [disabled]="disabled" *ngIf="questionIndex == editingIndex && !disabled"
                  styleClass="input-button p-button-rounded p-button-danger p-button-text" (onClick)="
                    removeRowInTextInput(question, fieldIndex, questionIndex)
                  " icon="pi pi-trash"></p-button>
              </div>
              <div class="d-flex justify-content-start">
                <div class="d-flex column">
                  <span class="checkbox-txt-color my-3">
                    {{ "The text of the answer is multiple" | translator }}

                    {{ "the classes" | translator }}
                    <span class="bottom-dots">...................................................</span>
                    <span class="bottom-dots">...................................................</span>
                    <span class="bottom-dots">...................................................</span>
                  </span>
                </div>
              </div>
            </div>
            <p-button class="v4-plus" [disabled]="disabled" *ngIf="questionIndex == editingIndex && !disabled"
              (onClick)="addRowInTextInput(question, questionIndex)" icon="pi pi-plus"
              styleClass="p-button-rounded p-button-outlined"></p-button>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'CONTACT_INFO'">
          <div class="flex-start my-3" *ngIf="(disabled && isConditional) || (disabled && isLinked)">
            <p-button (onClick)="unlockQuestion()" [pTooltip]="'Unlock Question & Edit' | translator"
              styleClass="input-button p-button-rounded p-button-danger p-button-text" icon="pi pi-lock"></p-button>
          </div>
          <div class="row" *ngIf="isAssessment && !UserExternalFields">
            <div class="col-md-6 col-12 d-flex gap-2 justify-content-start my-4">
              <p-button (onClick)="openServiceModal(question)" styleC="qbl-btn"
                label="{{ 'Select Service' | translator }}"></p-button>
              <ng-container *ngIf="question?.meta?.serviceIcon && question?.meta?.servicelabel">
                <div class="minisbutton d-flex gap-2">
                  <img src="{{ staticFileUrl + question?.meta?.serviceIcon }}" class="ministry-logo" />
                  <h5 class="miniheading">
                    {{ question?.meta?.servicelabel }}
                  </h5>
                </div>
                <p-button (onClick)="launchUrl(question.meta.service)" styleC="qbl-btn"
                  label="{{ 'Service' | translator }}" icon="pi pi-external-link"></p-button>
              </ng-container>
            </div>
          </div>
          <div class="input-with-button column flex-row"
            *ngIf="survey.topics != undefined && survey.topics.length > 0 && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{
                "ClassificationQue" | translator
                }}</span>
              <!-- p-dropdown [options]="survey.topics" [(selection)]="question.meta.selectedTopic"  [placeholder]="'Select Question Topics' | translator" ></p-dropdown -->

              <p-tree [value]="survey.topics" selectionMode="single" [(selection)]="question.meta.selectedTopic"
                emptyMessage="{{'No question classification created' | translator}}"
                (onNodeSelect)="toggleSelection($event)"></p-tree>
            </div>
          </div>
          <div class="input-with-button column flex-row" *ngIf="(isAssessment || isTopic) && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start" *ngIf="!fromTraining">
              <span class="ans-color">{{
                "Difficulty Level" | translator
                }}</span>
              <p-dropdown [options]="difficultyLevels" [(ngModel)]="question.meta.difficultyLevel"></p-dropdown>
            </div>
          </div>
          <div class="input-with-button column flex-row my-2" *ngIf="isAssessment && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Marks" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field" placeholder="{{ 'Marks' | translator }}"
                [disabled]="disabled" [inputStyle]="{
                                  'background-color': 'transparent',
                                  'border': 'none',
                                  'border-bottom': 'solid 1px lightgrey',
                                  'border-radius': '0px',
                                  'width': '100%',
                                  'color': 'white',
                              }" [(ngModel)]="question.meta.marks" />
            </div>
          </div>
          <div *ngIf="!UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Description" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.description" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div *ngIf="(isAssessment || isTopic) && !UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Feedback" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.feedback" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div class="column">
            <div class="input-with-button column flex-row my-4 "
              [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
              <input [disabled]="disabled" style="
                  background-color: transparent;
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                  color: white;
                " class="input-field 13" [placeholder]="question.meta.placeholder" [(ngModel)]="question.questionText"
                type="text" pInputText />
              <p-button [disabled]="disabled" styleClass="input-button p-button-rounded p-button-danger p-button-text"
                (onClick)="removeQuestion(questionIndex, UserExternalFields)" icon="pi pi-trash"></p-button>
            </div>
            <div class="d-flex justify-content-start">
              <div class="d-flex column my-4">
                <div class="d-flex column width-320px"
                  *ngFor="let field of question.meta.fields;let fieldIndex = index">
                  <div class="d-flex my-1 align-items-center justify-content-start">
                    <input [disabled]="disabled" style="
                        background-color: transparent;
                        border: none;
                        border-bottom: solid 1px lightgrey;
                        border-radius: 0px;
                        width: 100%;
                        color: white;
                      " class="input-field" [placeholder]="field.placeholder" 
                  [(ngModel)]="field.label"
                  (focus)="storeOldValue(field)"
                  (ngModelChange)="onLabelChange(field, $event)" type="text"
                      pInputText />
                    <p-button [disabled]="disabled" *ngIf="questionIndex == editingIndex && !disabled" (click)="
                        removeRowInTextInput(
                          question,
                          fieldIndex,
                          questionIndex
                        )
                      " styleClass="input-button p-button-rounded p-button-danger p-button-text"
                      icon="pi pi-trash"></p-button>
                  </div>
                  <div class="d-flex row align-items-start gap-2 mt-2 mb-2">
                    <div class="d-flex align-items-center gap-2">
                      <p-checkbox class="v4-color-white" name="isNumeric" inputId="isNumeric" [binary]="true"
                        [(ngModel)]="field.isNumeric"></p-checkbox>
                      <label class="v4-color-white" for="isNumeric">{{
                        "isNumeric" | translator
                        }}</label>
                    </div>
                    <div class="d-flex align-items-center gap-1" *ngIf="field.isNumeric">
                      <span class="ans-color">{{ "Limit" | translator }}</span>
                      <p-inputNumber inputId="integeronly" class="input-number-field"
                        placeholder="{{ 'Limit' | translator }}" [disabled]="disabled" [inputStyle]="{
                                          'background-color': 'transparent',
                                          'border': 'none',
                                          'border-bottom': 'solid 1px lightgrey',
                                          'border-radius': '0px',
                                          'width': '100%',
                                          'color': 'white',
                                      }" [(ngModel)]="field.isNumericLimit" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p-button class="v4-plus" [disabled]="disabled" (onClick)="addRowInTextInput(question, questionIndex)"
              icon="pi pi-plus" styleClass="p-button-rounded p-button-outlined"></p-button>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'SINGLE_ROW_TEXT'">
          <div class="flex-start my-3" *ngIf="(disabled && isConditional) || (disabled && isLinked)">
            <p-button (onClick)="unlockQuestion()" [pTooltip]="'Unlock Question & Edit' | translator"
              styleClass="input-button p-button-rounded p-button-danger p-button-text" icon="pi pi-lock"></p-button>
          </div>
          <div class="row" *ngIf="isAssessment && !UserExternalFields">
            <div class="col-md-6 col-12 d-flex gap-2 justify-content-start my-4">
              <p-button (onClick)="openServiceModal(question)" styleC="qbl-btn"
                label="{{ 'Select Service' | translator }}"></p-button>
              <ng-container *ngIf="question?.meta?.serviceIcon && question?.meta?.servicelabel">
                <div class="minisbutton d-flex gap-2">
                  <img src="{{ staticFileUrl + question?.meta?.serviceIcon }}" class="ministry-logo" />
                  <h5 class="miniheading">
                    {{ question?.meta?.servicelabel }}
                  </h5>
                </div>
                <p-button (onClick)="launchUrl(question.meta.service)" styleC="qbl-btn"
                  label="{{ 'Service' | translator }}" icon="pi pi-external-link"></p-button>
              </ng-container>
            </div>
          </div>
          <div class="input-with-button column flex-row"
            *ngIf="survey.topics != undefined && survey.topics.length > 0 && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{
                "ClassificationQue" | translator
                }}</span>
              <!-- p-dropdown [options]="survey.topics" [(selection)]="question.meta.selectedTopic"  [placeholder]="'Select Question Topics' | translator" ></p-dropdown -->

              <p-tree [value]="survey.topics" selectionMode="single" [(selection)]="question.meta.selectedTopic"
                emptyMessage="{{'No question classification created' | translator}}"
                (onNodeSelect)="toggleSelection($event)"></p-tree>
            </div>
          </div>
          <div class="input-with-button column flex-row" *ngIf="(isAssessment || isTopic) && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start" *ngIf="!fromTraining">
              <span class="ans-color">{{
                "Difficulty Level" | translator
                }}</span>
              <p-dropdown [options]="difficultyLevels" [(ngModel)]="question.meta.difficultyLevel"></p-dropdown>
            </div>
          </div>
          <div class="input-with-button column flex-row my-2" *ngIf="isAssessment && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Marks" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field" placeholder="{{ 'Marks' | translator }}"
                [disabled]="disabled" [inputStyle]="{
                                  'background-color': 'transparent',
                                  'border': 'none',
                                  'border-bottom': 'solid 1px lightgrey',
                                  'border-radius': '0px',
                                  'width': '100%',
                                  'color': 'white',
                              }" [(ngModel)]="question.meta.marks" />
            </div>
          </div>
          <div *ngIf="!UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Description" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.description" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div *ngIf="(isAssessment || isTopic) && !UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Feedback" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.feedback" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div *ngFor="let field of question.meta.fields; let fieldIndex = index" class="column">
            <div class="input-with-button column flex-row my-4 "
              [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
              <input [disabled]="disabled" style="
                  background-color: transparent;
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                  color: white;
                " class="input-field 14" [placeholder]="field.placeholder" 
                  [(ngModel)]="field.label"
                  (focus)="storeOldValue(field)"
                  (ngModelChange)="onLabelChange(field, $event)" type="text"
                pInputText />

              <p-button [disabled]="disabled" *ngIf="questionIndex == editingIndex && !disabled" (click)="
                  removeRowInTextInput(question, fieldIndex, questionIndex)
                " styleClass="input-button p-button-rounded p-button-danger p-button-text"
                icon="pi pi-trash"></p-button>
            </div>
            <div class="d-flex column justify-content-start">
              <div class="d-flex column my-2">
                <span class="ans-color">{{ field.valueLabel }}</span>
                <span class="dotted-bottom mb-3">..............................................................</span>
              </div>
              <div class="d-flex column align-items-start gap-2">
                <div class="d-flex align-items-center gap-2">
                  <p-checkbox class="v4-color-white" name="isNumeric" inputId="isNumeric" [binary]="true"
                    [(ngModel)]="field.isNumeric"></p-checkbox>
                  <label class="v4-color-white" for="isNumeric">{{
                    "isNumeric" | translator
                    }}</label>
                </div>
                <div class="d-flex align-items-center gap-1" *ngIf="field.isNumeric">
                  <span class="ans-color">{{ "Limit" | translator }}</span>
                  <p-inputNumber inputId="integeronly" class="input-number-field"
                    placeholder="{{ 'Limit' | translator }}" [disabled]="disabled" [inputStyle]="{
                                      'background-color': 'transparent',
                                      'border': 'none',
                                      'border-bottom': 'solid 1px lightgrey',
                                      'border-radius': '0px',
                                      'width': '100%',
                                      'color': 'white',
                                  }" [(ngModel)]="field.isNumericLimit" />
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="questionIndex == editingIndex && !disabled" class="d-flex justify-content-start my-2">
            <p-button class="v4-plus" [disabled]="disabled" (onClick)="addRowInTextInput(question, questionIndex)"
              icon="pi pi-plus" styleClass="p-button-rounded p-button-outlined"></p-button>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'EMAIL_ADDRESS'">
          <div class="flex-start my-3" *ngIf="(disabled && isConditional) || (disabled && isLinked)">
            <p-button (onClick)="unlockQuestion()" [pTooltip]="'Unlock Question & Edit' | translator"
              styleClass="input-button p-button-rounded p-button-danger p-button-text" icon="pi pi-lock"></p-button>
          </div>
          <div class="row" *ngIf="isAssessment && !UserExternalFields">
            <div class="col-md-6 col-12 d-flex gap-2 justify-content-start my-4">
              <p-button (onClick)="openServiceModal(question)" styleC="qbl-btn"
                label="{{ 'Select Service' | translator }}"></p-button>
              <ng-container *ngIf="question?.meta?.serviceIcon && question?.meta?.servicelabel">
                <div class="minisbutton d-flex gap-2">
                  <img src="{{ staticFileUrl + question?.meta?.serviceIcon }}" class="ministry-logo" />
                  <h5 class="miniheading">
                    {{ question?.meta?.servicelabel }}
                  </h5>
                </div>
                <p-button (onClick)="launchUrl(question.meta.service)" styleC="qbl-btn"
                  label="{{ 'Service' | translator }}" icon="pi pi-external-link"></p-button>
              </ng-container>
            </div>
          </div>
          <div class="input-with-button column flex-row"
            *ngIf="survey.topics != undefined && survey.topics.length > 0 && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{
                "ClassificationQue" | translator
                }}</span>
              <!-- p-dropdown [options]="survey.topics" [(selection)]="question.meta.selectedTopic"  [placeholder]="'Select Question Topics' | translator" ></p-dropdown -->

              <p-tree [value]="survey.topics" selectionMode="single" [(selection)]="question.meta.selectedTopic"
                emptyMessage="{{'No question classification created' | translator}}"
                (onNodeSelect)="toggleSelection($event)"></p-tree>
            </div>
          </div>
          <div class="input-with-button column flex-row" *ngIf="(isAssessment || isTopic) && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start" *ngIf="!fromTraining">
              <span class="ans-color">{{
                "Difficulty Level" | translator
                }}</span>
              <p-dropdown [options]="difficultyLevels" [(ngModel)]="question.meta.difficultyLevel"></p-dropdown>
            </div>
          </div>
          <div class="input-with-button column flex-row my-2" *ngIf="isAssessment && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Marks" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field" placeholder="{{ 'Marks' | translator }}"
                [disabled]="disabled" [inputStyle]="{
                                  'background-color': 'transparent',
                                  'border': 'none',
                                  'border-bottom': 'solid 1px lightgrey',
                                  'border-radius': '0px',
                                  'width': '100%',
                                  'color': 'white',
                              }" [(ngModel)]="question.meta.marks" />
            </div>
          </div>
          <div *ngIf="!UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Description" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.description" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div *ngIf="(isAssessment || isTopic) && !UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Feedback" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.feedback" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div *ngFor="let field of question.meta.fields; let fieldIndex = index" class="column">
            <div class="input-with-button column flex-row my-4 "
              [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
              <input [disabled]="disabled" style="
                  background-color: transparent;
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                  color: white;
                " class="input-field 15" placeholder="Name" [placeholder]="field.placeholder" 
                  [(ngModel)]="field.label"
                  (focus)="storeOldValue(field)"
                  (ngModelChange)="onLabelChange(field, $event)"
                type="text" pInputText />
              <p-button [disabled]="disabled" *ngIf="questionIndex == editingIndex && !disabled" (click)="
                  removeRowInTextInput(question, fieldIndex, questionIndex)
                " styleClass="input-button p-button-rounded p-button-danger p-button-text"
                icon="pi pi-trash"></p-button>
            </div>
            <div class="d-flex justify-content-start">
              <div class="d-flex column my-4">
                <span class="ans-color">{{ field.valueLabel }}</span>
                <span class="dotted-bottom mb-3">..............................................................</span>
              </div>
            </div>
          </div>
          <div *ngIf="questionIndex == editingIndex && !disabled" class="d-flex justify-content-start my-2">
            <p-button class="v4-plus" [disabled]="disabled" (onClick)="addRowInTextInput(question, questionIndex)"
              icon="pi pi-plus" styleClass="p-button-rounded p-button-outlined"></p-button>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'DROPDOWN_MENU'">
          <div class="flex-start my-3" *ngIf="(disabled && isConditional) || (disabled && isLinked)">
            <p-button (onClick)="unlockQuestion()" [pTooltip]="'Unlock Question & Edit' | translator"
              styleClass="input-button p-button-rounded p-button-danger p-button-text" icon="pi pi-lock"></p-button>
          </div>
          <div class="row" *ngIf="isAssessment && !UserExternalFields">
            <div class="col-md-6 col-12 d-flex gap-2 justify-content-start my-4">
              <p-button (onClick)="openServiceModal(question)" styleC="qbl-btn"
                label="{{ 'Select Service' | translator }}"></p-button>
              <ng-container *ngIf="question?.meta?.serviceIcon && question?.meta?.servicelabel">
                <div class="minisbutton d-flex gap-2">
                  <img src="{{ staticFileUrl + question?.meta?.serviceIcon }}" class="ministry-logo" />
                  <h5 class="miniheading">
                    {{ question?.meta?.servicelabel }}
                  </h5>
                </div>
                <p-button (onClick)="launchUrl(question.meta.service)" styleC="qbl-btn"
                  label="{{ 'Service' | translator }}" icon="pi pi-external-link"></p-button>
              </ng-container>
            </div>
          </div>
          <div class="input-with-button column flex-row"
            *ngIf="survey.topics != undefined && survey.topics.length > 0 && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{
                "ClassificationQue" | translator
                }}</span>
              <!-- p-dropdown [options]="survey.topics" [(selection)]="question.meta.selectedTopic"  [placeholder]="'Select Question Topics' | translator" ></p-dropdown -->

              <p-tree [value]="survey.topics" selectionMode="single" [(selection)]="question.meta.selectedTopic"
                emptyMessage="{{'No question classification created' | translator}}"
                (onNodeSelect)="toggleSelection($event)"></p-tree>
            </div>
          </div>
          <div class="input-with-button column flex-row" *ngIf="(isAssessment || isTopic) && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start" *ngIf="!fromTraining">
              <span class="ans-color">{{
                "Difficulty Level" | translator
                }}</span>
              <p-dropdown [options]="difficultyLevels" [(ngModel)]="question.meta.difficultyLevel"></p-dropdown>
            </div>
          </div>
          <div class="input-with-button column flex-row my-2" *ngIf="isAssessment && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Marks" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field" placeholder="{{ 'Marks' | translator }}"
                [disabled]="disabled" [inputStyle]="{
                                  'background-color': 'transparent',
                                  'border': 'none',
                                  'border-bottom': 'solid 1px lightgrey',
                                  'border-radius': '0px',
                                  'width': '100%',
                                  'color': 'white',
                              }" [(ngModel)]="question.meta.marks" />
            </div>
          </div>
          <div *ngIf="!UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Description" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.description" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div *ngIf="(isAssessment || isTopic) && !UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Feedback" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.feedback" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div class="column">
            <div class="input-with-button column flex-row my-4 "
              [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
              <input [disabled]="disabled" style="
                  background-color: transparent;
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                  color: white;
                " class="input-field 16" [placeholder]="question.meta.placeholder" [(ngModel)]="question.questionText"
                type="text" pInputText />
              <p-button [disabled]="disabled" styleClass="input-button p-button-rounded p-button-danger p-button-text"
                (onClick)="removeQuestion(questionIndex, UserExternalFields)" icon="pi pi-trash"></p-button>
            </div>
            <div class="d-flex justify-content-start">
              <div class="d-flex column my-4">
                <span *ngIf="isAssessment || isTopic; else surveyTemplate">
                  <p-dropdown [disabled]="disabled" styleClass="border" [options]="question.meta.fields"
                    [(ngModel)]="question.meta.correct" optionLabel="label" optionValue="label"
                    [placeholder]="'Select Correct Answer' | translator" (ngModelChange)="print($event)"
                    *ngIf="!question.editing; else editingTemplate" appendTo="body"></p-dropdown>
                </span>
                <ng-template #surveyTemplate>
                  <p-dropdown [disabled]="disabled" styleClass="border" [options]="question.meta.fields"
                    optionLabel="label" *ngIf="!question.editing; else editingTemplate" appendTo="body"></p-dropdown>
                </ng-template>
                <ng-template #editingTemplate>
                  <div class="d-flex column width-320px" *ngFor="
                      let field of question.meta.fields;
                      let fieldIndex = index
                    ">
                    <div class="d-flex my-1 align-items-center justify-content-start">
                      <input [disabled]="disabled" style="
                          background-color: transparent;
                          border: none;
                          border-bottom: solid 1px lightgrey;
                          border-radius: 0px;
                          width: 100%;
                          color: white;
                        " class="input-field" [placeholder]="field.placeholder" 
                  [(ngModel)]="field.label"
                  (focus)="storeOldValue(field)"
                  (ngModelChange)="onLabelChange(field, $event)" type="text"
                        pInputText />

                      <p-button [disabled]="disabled" *ngIf="questionIndex == editingIndex && !disabled" (click)="
                          removeRowInTextInput(
                            question,
                            fieldIndex,
                            questionIndex
                          )
                        " styleClass="input-button p-button-rounded p-button-danger p-button-text"
                        icon="pi pi-trash"></p-button>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
            <div *ngIf="question.editing; else editingButton">
              <p-button class="v4-plus" [disabled]="disabled" (onClick)="addRowInTextInput(question, questionIndex)"
                icon="pi pi-plus" styleClass="p-button-rounded p-button-outlined"></p-button>
              <p-button class="v4-plus" [disabled]="disabled" (onClick)="question.editing = false" icon="pi pi-check"
                styleClass="p-button-rounded p-button-outlined mx-3"></p-button>
            </div>
            <ng-template #editingButton>
              <p-button class="v4-plus" [disabled]="disabled" (onClick)="question.editing = true" icon="pi pi-pencil"
                styleClass="p-button-rounded p-button-outlined"></p-button>
            </ng-template>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'SELECT_ONE'">
          <div class="flex-start my-3" *ngIf="(disabled && isConditional) || (disabled && isLinked)">
            <p-button (onClick)="unlockQuestion()" [pTooltip]="'Unlock Question & Edit' | translator"
              styleClass="input-button p-button-rounded p-button-danger p-button-text" icon="pi pi-lock"></p-button>
          </div>
          <div class="row" *ngIf="isAssessment && !UserExternalFields">
            <div class="col-md-6 col-12 d-flex gap-2 justify-content-start my-4">
              <p-button (onClick)="openServiceModal(question)" styleC="qbl-btn"
                label="{{ 'Select Service' | translator }}"></p-button>
              <ng-container *ngIf="question?.meta?.serviceIcon && question?.meta?.servicelabel">
                <div class="minisbutton d-flex gap-2">
                  <img src="{{ staticFileUrl + question?.meta?.serviceIcon }}" class="ministry-logo" />
                  <h5 class="miniheading">
                    {{ question?.meta?.servicelabel }}
                  </h5>
                </div>
                <p-button (onClick)="launchUrl(question.meta.service)" styleC="qbl-btn"
                  label="{{ 'Service' | translator }}" icon="pi pi-external-link"></p-button>
              </ng-container>
            </div>
          </div>
          <div class="input-with-button column flex-row"
            *ngIf="survey.topics != undefined && survey.topics.length > 0 && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{
                "ClassificationQue" | translator
                }}</span>
              <!-- p-dropdown [options]="survey.topics" [(selection)]="question.meta.selectedTopic"  [placeholder]="'Select Question Topics' | translator" ></p-dropdown -->

              <p-tree [value]="survey.topics" selectionMode="single" [(selection)]="question.meta.selectedTopic"
                emptyMessage="{{'No question classification created' | translator}}"
                (onNodeSelect)="toggleSelection($event)"></p-tree>
            </div>
          </div>
          <div class="input-with-button column flex-row" *ngIf="(isAssessment || isTopic) && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start" *ngIf="!fromTraining">
              <span class="ans-color">{{
                "Difficulty Level" | translator
                }}</span>
              <p-dropdown [options]="difficultyLevels" [(ngModel)]="question.meta.difficultyLevel"></p-dropdown>
            </div>
          </div>
          <div class="input-with-button column flex-row my-2" *ngIf="isAssessment && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Marks" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field" placeholder="{{ 'Marks' | translator }}"
                [disabled]="disabled" [inputStyle]="{
                                  'background-color': 'transparent',
                                  'border': 'none',
                                  'border-bottom': 'solid 1px lightgrey',
                                  'border-radius': '0px',
                                  'width': '100%',
                                  'color': 'white',
                              }" [(ngModel)]="question.meta.marks" />
            </div>
          </div>
          <div *ngIf="!UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Description" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.description" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div *ngIf="(isAssessment || isTopic) && !UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Feedback" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.feedback" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <!-- Select One Question -->
          <div class="input-with-button column flex-row my-4 "
            [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
            <input [disabled]="disabled" style="
                background-color: transparent;
                border: none;
                border-bottom: solid 1px lightgrey;
                border-radius: 0px;
                width: 100%;
                color: white;
              " class="input-field 17" [placeholder]="question.meta.placeholder" [(ngModel)]="question.questionText"
              type="text" pInputText />
            <p-button [disabled]="disabled" *ngIf="questionIndex == editingIndex && !disabled"
              (onClick)="removeQuestion(questionIndex, UserExternalFields)" styleClass="input-button" icon="pi pi-trash"
              styleClass="input-button p-button-rounded p-button-danger p-button-text"></p-button>
          </div>
          <div class="d-flex justify-content-start column">
            <div class="flex flex-wrap gap-3" *ngFor="let field of question.meta.fields; let fieldIndex = index">
              <div class="flex align-items-center">
                <p-radioButton [disabled]="(field.label == '') ? true : disabled"
                  *ngIf="isAssessment || isTopic; else surveyTemplate" [name]="question.questionText"
                  [(ngModel)]="question.meta.correct" [value]="field.label"></p-radioButton>
                <ng-template #surveyTemplate>
                  <span class="pi pi-circle"></span>
                </ng-template>
                <input [disabled]="disabled" style="
                    background-color: transparent;
                    border: none;
                    border-bottom: solid 1px lightgrey;
                    border-radius: 0px;
                    color: white;
                  " class="input-field mx-2" [placeholder]="field.placeholder" [(ngModel)]="field.label" type="text"
                  (focus)="storeOldValue(field)"
                  (ngModelChange)="onLabelChange(field, $event)"
                  pInputText />
                <p-button [disabled]="disabled" *ngIf="
                    question.meta.fields.length > 1 &&
                    questionIndex == editingIndex &&
                    !disabled
                  " (onClick)="
                    removeRowInTextInput(question, fieldIndex, questionIndex)
                  " styleClass="input-button p-button-rounded p-button-danger p-button-text"
                  icon="pi pi-trash"></p-button>
              </div>
            </div>
            <div *ngIf="questionIndex == editingIndex && !disabled" class="d-flex justify-content-start my-4">
              <p-button class="v4-plus" [disabled]="disabled" icon="pi pi-plus"
                (onClick)="addRowInTextInput(question, questionIndex)"
                styleClass="p-button-rounded p-button-outlined"></p-button>
            </div>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'IMPACT_MEASUREMENT'">
          <div class="flex-start my-3" *ngIf="(disabled && isConditional) || (disabled && isLinked)">
            <p-button (onClick)="unlockQuestion()" [pTooltip]="'Unlock Question & Edit' | translator"
              styleClass="input-button p-button-rounded p-button-danger p-button-text" icon="pi pi-lock"></p-button>
          </div>
          <div class="row" *ngIf="isAssessment && !UserExternalFields">
            <div class="col-md-6 col-12 d-flex gap-2 justify-content-start my-4">
              <p-button (onClick)="openServiceModal(question)" styleC="qbl-btn"
                label="{{ 'Select Service' | translator }}"></p-button>
              <ng-container *ngIf="question?.meta?.serviceIcon && question?.meta?.servicelabel">
                <div class="minisbutton d-flex gap-2">
                  <img src="{{ staticFileUrl + question?.meta?.serviceIcon }}" class="ministry-logo" />
                  <h5 class="miniheading">
                    {{ question?.meta?.servicelabel }}
                  </h5>
                </div>
                <p-button (onClick)="launchUrl(question.meta.service)" styleC="qbl-btn"
                  label="{{ 'Service' | translator }}" icon="pi pi-external-link"></p-button>
              </ng-container>
            </div>
          </div>
          <div class="input-with-button column flex-row"
            *ngIf="survey.topics != undefined && survey.topics.length > 0 && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{
                "ClassificationQue" | translator
                }}</span>
              <!-- p-dropdown [options]="survey.topics" [(selection)]="question.meta.selectedTopic"  [placeholder]="'Select Question Topics' | translator" ></p-dropdown -->

              <p-tree [value]="survey.topics" selectionMode="single" [(selection)]="question.meta.selectedTopic"
                emptyMessage="{{'No question classification created' | translator}}"
                (onNodeSelect)="toggleSelection($event)"></p-tree>
            </div>
          </div>
          <div class="input-with-button column flex-row" *ngIf="(isAssessment || isTopic) && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start" *ngIf="!fromTraining">
              <span class="ans-color">{{
                "Difficulty Level" | translator
                }}</span>
              <p-dropdown [options]="difficultyLevels" [(ngModel)]="question.meta.difficultyLevel"></p-dropdown>
            </div>
          </div>
          <div class="input-with-button column flex-row my-2" *ngIf="isAssessment && !UserExternalFields">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Marks" | translator }}</span>
              <p-inputNumber inputId="integeronly" class="input-number-field" placeholder="{{ 'Marks' | translator }}"
                [disabled]="disabled" [inputStyle]="{
                                  'background-color': 'transparent',
                                  'border': 'none',
                                  'border-bottom': 'solid 1px lightgrey',
                                  'border-radius': '0px',
                                  'width': '100%',
                                  'color': 'white',
                              }" [(ngModel)]="question.meta.marks" />
            </div>
          </div>
          <div *ngIf="!UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Description" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.description" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <div *ngIf="(isAssessment || isTopic) && !UserExternalFields" class="input-with-button column flex-row mt-2">
            <div class="d-flex column gap-1 align-items-start justify-content-start">
              <span class="ans-color">{{ "Feedback" | translator }}</span>
              <p-editor [(ngModel)]="question.meta.feedback" class="w-100" [style]="{ height: '100px' }"></p-editor>
            </div>
          </div>
          <!-- star Rating -->
          <div class="column">
            <div class="input-with-button column flex-row my-4 "
              [ngClass]="{'v4-q-border': !question.meta.labelError, 'v4-q-border-danger': question.meta.labelError}">
              <input [disabled]="disabled" style="
                  background-color: transparent;
                  border: none;
                  border-bottom: solid 1px lightgrey;
                  border-radius: 0px;
                  width: 100%;
                  color: white;
                " class="input-field 10" [placeholder]="question.meta.placeholder" [(ngModel)]="question.questionText"
                type="text" pInputText />
              <p-button [disabled]="disabled" *ngIf="questionIndex == editingIndex && !disabled"
                styleClass="input-button p-button-rounded p-button-danger p-button-text"
                (onClick)="removeQuestion(questionIndex, UserExternalFields)" icon="pi pi-trash"></p-button>
            </div>

            <div class="input-with-button column flex-row mt-2">
              <div class="d-flex column gap-1 align-items-start justify-content-start">
                <span class="ans-color">{{ "Correct Answer" | translator }}</span>
                <p-editor [(ngModel)]="question.meta.correctAnswer" class="w-100"
                  [style]="{ height: '100px' }"></p-editor>
              </div>
            </div>

            <div class="d-flex justify-content-start">
              <div class="d-flex column my-4">
                <span class="ans-color">{{ 'Employee Answer' | translator }}</span>
                <span class="dotted-bottom mb-3">..............................................................</span>
              </div>
            </div>

            <div class="row w-100">
              <div class="row w-100" *ngFor="
                  let field of question.meta.fields;
                  let fieldIndex = index
                ">
                <div class="col-md-4 col-12 my-2">
                  <input [disabled]="disabled" style="
                      background-color: transparent;
                      border: none;
                      border-bottom: solid 1px lightgrey;
                      border-radius: 0px;
                      width: 100%;
                      color: white;
                    " class="input-field" [placeholder]="field.placeholder" 
                  [(ngModel)]="field.label"
                  (focus)="storeOldValue(field)"
                  (ngModelChange)="onLabelChange(field, $event)" type="text"
                    pInputText />
                </div>
                <div class="col-md-8 col-12 d-flex align-items-end my-2">
                  <p-rating [disabled]="disabled" [(ngModel)]="field.correct" [cancel]="false"></p-rating>
                </div>
                <div class="col-md-4 col-12 d-flex align-items-end">
                  <p-button [disabled]="disabled" *ngIf="questionIndex == editingIndex && !disabled" (click)="
                      removeRowInTextInput(question, fieldIndex, questionIndex)
                    " styleClass="input-button p-button-rounded p-button-danger p-button-text"
                    icon="pi pi-trash"></p-button>
                </div>
              </div>
              <div class="col-md-12 col-12 my-2" *ngIf="questionIndex == editingIndex && !disabled">
                <p-button class="v4-plus" [disabled]="disabled" (onClick)="addRowInTextInput(question, questionIndex)"
                  icon="pi pi-plus" styleClass="p-button-rounded p-button-outlined"></p-button>
              </div>
            </div>

            <div class="d-flex justify-content-start">
              <div class="d-flex column my-4">
                <span class="ans-color">{{ 'Comments' | translator }}</span>
                <span class="dotted-bottom mb-3">..............................................................</span>
              </div>
            </div>
          </div>
          <!-- star Rating End -->
        </ng-container>

        <div *ngIf="isImpactSurvey" class="d-flex flex-row gap-2">
          <div class="d-flex align-items-center gap-1" style="margin-top: 1.5rem">
            <p-checkbox class="v4-color-white" name="forTrainer" inputId="forTrainer" [binary]="true"
              [(ngModel)]="question.meta.forTrainer"></p-checkbox>
            <label class="v4-color-white" for="forTrainer">{{
              "for Trainer" | translator
              }}</label>
          </div>
          <div class="d-flex align-items-center gap-1" style="margin-top: 1.5rem">
            <p-checkbox class="v4-color-white" name="forManager" inputId="forManager" [binary]="true"
              [(ngModel)]="question.meta.forManager"></p-checkbox>
            <label class="v4-color-white" for="forManager">{{
              "For Manager" | translator
              }}</label>
          </div>
        </div>
        <div *ngIf="!isAssessment && !isTopic && question.type != 'DYNAMIC_MESSAGE'" class="">
          <div class="d-flex align-items-center gap-1" style="margin-top: 1.5rem">
            <p-checkbox class="v4-color-white" name="validReq" inputId="validReq" [binary]="true"
              [(ngModel)]="question.meta.validReq"></p-checkbox>
            <label class="v4-color-white" for="validReq">{{
              "required" | translator
              }}</label>
          </div>
        </div>

        <div *ngIf="conditionalQuestions.length > 0 && !isAssessment && !isTopic" style="margin-top: 1.5rem">
          <div class="d-flex align-items-center gap-1">
            <p-checkbox class="v4-color-white" name="conditional" inputId="conditional" [binary]="true"
              [(ngModel)]="question.meta.conditional"></p-checkbox>
            <label class="v4-color-white" for="conditional">{{
              "Conditional" | translator
              }}</label>
          </div>

          <div *ngIf="question.meta.conditional"
            class="d-flex align-items-right justify-content-between flex-column my-2 gap-3">
            <p-dropdown id="select-question" class="conditional-dd" [filter]="true" filterBy="questionText"
              optionLabel="questionText" [placeholder]="getPlaceholder()"
              [options]="disableConditionalOptions(question)" optionDisabled="disabled"
              [(ngModel)]="selectedQuestion"></p-dropdown>
            <p-dropdown class="conditional-dd" [filter]="true" filterBy="label" optionLabel="label"
              [options]="getConditionalOptions(question)" [placeholder]="'Select Option' | translator"
              [(ngModel)]="selectedOption"></p-dropdown>
          </div>
        </div>

        <!-- Link Questions -->
        <div *ngIf="linkedQuestions.length > 0 && !canLinked(question) && isTopic && question.type != 'DYNAMIC_MESSAGE'"
          style="margin-top: 1.5rem">
          <div class="d-flex align-items-center gap-1">
            <p-checkbox class="v4-color-white" name="conditional" inputId="conditional" [binary]="true"
              [(ngModel)]="question.meta.linked"></p-checkbox>
            <label class="v4-color-white" for="Link Question">{{
              "Link Question" | translator
              }}</label>
          </div>

          <div *ngIf="question.meta.linked"
            class="d-flex align-items-right justify-content-between flex-column my-2 gap-3">
            <p-dropdown id="link-question" class="conditional-dd" [filter]="true" filterBy="questionText"
              optionLabel="questionText" [placeholder]="getLinkPlaceholder()" [options]="disableLinkedOptions(question)"
              optionDisabled="disabled" [(ngModel)]="selectedLinkQuestion"></p-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<p-dialog [blockScroll]="true" [draggable]="false" header="{{'Select Service' | translator}}" [maximizable]="true"
  [(visible)]="showSelectServiceModal" [style]="{ width: '95vw', maxWidth: '1700px', maxHeight: '900px' }">
  <div style=" padding: 15px; background-color: rgba(255, 255, 255, 0.09); border-radius: 15px;">
    <app-select-service (currentDataItem)="setServiceLink($event)"></app-select-service>
  </div>
</p-dialog>